"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
require("core-js/modules/es6.regexp.replace.js");
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _button = require("@gravity/button");
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _inputTextFilter = _interopRequireDefault(require("@gravity/input-text-filter"));
var _multidropdown = _interopRequireDefault(require("@gravity/multidropdown"));
var _price = _interopRequireDefault(require("@gravity/price"));
var _priceRangeFilter = _interopRequireDefault(require("@gravity/price-range-filter"));
var _themeMapper = require("@gravity/theme-mapper");
var _themeProvider = require("@gravity/theme-provider");
var _utils = require("@gravity/utils");
var _filter = require("@nucleo/filter");
var _format = _interopRequireDefault(require("date-fns/format"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _size = _interopRequireDefault(require("lodash/size"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = require("styled-components");
var _FilterStyling = require("./FilterStyling");
var _helper = require("./helper");
var _jsxFileName = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/FilterBar/lib/FilterBar.js";
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_21uayl3lxb() {
  var path = "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/FilterBar/lib/FilterBar.js";
  var hash = "97edfe9addefd6e5382ae00f67590dd479cbc739";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src4001455011/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/functional/FilterBar/lib/FilterBar.js",
    statementMap: {
      "0": {
        start: {
          line: 53,
          column: 24
        },
        end: {
          line: 53,
          column: 26
        }
      },
      "1": {
        start: {
          line: 54,
          column: 24
        },
        end: {
          line: 54,
          column: 26
        }
      },
      "2": {
        start: {
          line: 55,
          column: 18
        },
        end: {
          line: 55,
          column: 20
        }
      },
      "3": {
        start: {
          line: 56,
          column: 28
        },
        end: {
          line: 59,
          column: 1
        }
      },
      "4": {
        start: {
          line: 61,
          column: 17
        },
        end: {
          line: 64,
          column: 1
        }
      },
      "5": {
        start: {
          line: 71,
          column: 36
        },
        end: {
          line: 87,
          column: 3
        }
      },
      "6": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "7": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 84,
          column: 8
        }
      },
      "8": {
        start: {
          line: 86,
          column: 4
        },
        end: {
          line: 86,
          column: 16
        }
      },
      "9": {
        start: {
          line: 90,
          column: 4
        },
        end: {
          line: 90,
          column: 17
        }
      },
      "10": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 102,
          column: 6
        }
      },
      "11": {
        start: {
          line: 111,
          column: 20
        },
        end: {
          line: 140,
          column: 3
        }
      },
      "12": {
        start: {
          line: 111,
          column: 66
        },
        end: {
          line: 140,
          column: 3
        }
      },
      "13": {
        start: {
          line: 113,
          column: 20
        },
        end: {
          line: 113,
          column: 25
        }
      },
      "14": {
        start: {
          line: 114,
          column: 30
        },
        end: {
          line: 114,
          column: 74
        }
      },
      "15": {
        start: {
          line: 115,
          column: 21
        },
        end: {
          line: 115,
          column: 42
        }
      },
      "16": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 132,
          column: 5
        }
      },
      "17": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 56
        }
      },
      "18": {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 119,
          column: 42
        }
      },
      "19": {
        start: {
          line: 120,
          column: 8
        },
        end: {
          line: 120,
          column: 46
        }
      },
      "20": {
        start: {
          line: 121,
          column: 8
        },
        end: {
          line: 121,
          column: 44
        }
      },
      "21": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 122,
          column: 14
        }
      },
      "22": {
        start: {
          line: 124,
          column: 8
        },
        end: {
          line: 126,
          column: 67
        }
      },
      "23": {
        start: {
          line: 127,
          column: 8
        },
        end: {
          line: 127,
          column: 61
        }
      },
      "24": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 61
        }
      },
      "25": {
        start: {
          line: 129,
          column: 8
        },
        end: {
          line: 129,
          column: 14
        }
      },
      "26": {
        start: {
          line: 131,
          column: 8
        },
        end: {
          line: 131,
          column: 14
        }
      },
      "27": {
        start: {
          line: 134,
          column: 4
        },
        end: {
          line: 139,
          column: 6
        }
      },
      "28": {
        start: {
          line: 142,
          column: 29
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "29": {
        start: {
          line: 142,
          column: 37
        },
        end: {
          line: 160,
          column: 3
        }
      },
      "30": {
        start: {
          line: 143,
          column: 30
        },
        end: {
          line: 143,
          column: 74
        }
      },
      "31": {
        start: {
          line: 145,
          column: 25
        },
        end: {
          line: 145,
          column: 69
        }
      },
      "32": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 155,
          column: 5
        }
      },
      "33": {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 148,
          column: 53
        }
      },
      "34": {
        start: {
          line: 149,
          column: 8
        },
        end: {
          line: 149,
          column: 14
        }
      },
      "35": {
        start: {
          line: 151,
          column: 8
        },
        end: {
          line: 151,
          column: 57
        }
      },
      "36": {
        start: {
          line: 152,
          column: 8
        },
        end: {
          line: 152,
          column: 14
        }
      },
      "37": {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 154,
          column: 14
        }
      },
      "38": {
        start: {
          line: 157,
          column: 4
        },
        end: {
          line: 159,
          column: 7
        }
      },
      "39": {
        start: {
          line: 165,
          column: 33
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "40": {
        start: {
          line: 165,
          column: 41
        },
        end: {
          line: 205,
          column: 3
        }
      },
      "41": {
        start: {
          line: 167,
          column: 20
        },
        end: {
          line: 167,
          column: 25
        }
      },
      "42": {
        start: {
          line: 168,
          column: 30
        },
        end: {
          line: 168,
          column: 74
        }
      },
      "43": {
        start: {
          line: 169,
          column: 25
        },
        end: {
          line: 169,
          column: 84
        }
      },
      "44": {
        start: {
          line: 169,
          column: 67
        },
        end: {
          line: 169,
          column: 76
        }
      },
      "45": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 197,
          column: 5
        }
      },
      "46": {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 78
        }
      },
      "47": {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 55
        }
      },
      "48": {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 14
        }
      },
      "49": {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 180,
          column: 66
        }
      },
      "50": {
        start: {
          line: 181,
          column: 8
        },
        end: {
          line: 181,
          column: 52
        }
      },
      "51": {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 14
        }
      },
      "52": {
        start: {
          line: 184,
          column: 8
        },
        end: {
          line: 184,
          column: 72
        }
      },
      "53": {
        start: {
          line: 185,
          column: 8
        },
        end: {
          line: 185,
          column: 58
        }
      },
      "54": {
        start: {
          line: 186,
          column: 8
        },
        end: {
          line: 186,
          column: 14
        }
      },
      "55": {
        start: {
          line: 188,
          column: 8
        },
        end: {
          line: 188,
          column: 76
        }
      },
      "56": {
        start: {
          line: 189,
          column: 8
        },
        end: {
          line: 189,
          column: 62
        }
      },
      "57": {
        start: {
          line: 190,
          column: 8
        },
        end: {
          line: 190,
          column: 14
        }
      },
      "58": {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 192,
          column: 70
        }
      },
      "59": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 193,
          column: 56
        }
      },
      "60": {
        start: {
          line: 194,
          column: 8
        },
        end: {
          line: 194,
          column: 14
        }
      },
      "61": {
        start: {
          line: 196,
          column: 8
        },
        end: {
          line: 196,
          column: 14
        }
      },
      "62": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 204,
          column: 6
        }
      },
      "63": {
        start: {
          line: 210,
          column: 22
        },
        end: {
          line: 214,
          column: 3
        }
      },
      "64": {
        start: {
          line: 210,
          column: 32
        },
        end: {
          line: 214,
          column: 3
        }
      },
      "65": {
        start: {
          line: 211,
          column: 4
        },
        end: {
          line: 213,
          column: 6
        }
      },
      "66": {
        start: {
          line: 216,
          column: 28
        },
        end: {
          line: 226,
          column: 3
        }
      },
      "67": {
        start: {
          line: 217,
          column: 4
        },
        end: {
          line: 224,
          column: 5
        }
      },
      "68": {
        start: {
          line: 218,
          column: 6
        },
        end: {
          line: 223,
          column: 8
        }
      },
      "69": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 56
        }
      },
      "70": {
        start: {
          line: 228,
          column: 21
        },
        end: {
          line: 237,
          column: 3
        }
      },
      "71": {
        start: {
          line: 229,
          column: 4
        },
        end: {
          line: 236,
          column: 5
        }
      },
      "72": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 231,
          column: 85
        }
      },
      "73": {
        start: {
          line: 233,
          column: 8
        },
        end: {
          line: 233,
          column: 93
        }
      },
      "74": {
        start: {
          line: 235,
          column: 8
        },
        end: {
          line: 235,
          column: 18
        }
      },
      "75": {
        start: {
          line: 240,
          column: 25
        },
        end: {
          line: 326,
          column: 3
        }
      },
      "76": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 243,
          column: 5
        }
      },
      "77": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 16
        }
      },
      "78": {
        start: {
          line: 244,
          column: 35
        },
        end: {
          line: 244,
          column: 68
        }
      },
      "79": {
        start: {
          line: 245,
          column: 27
        },
        end: {
          line: 245,
          column: 63
        }
      },
      "80": {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 249,
          column: 89
        }
      },
      "81": {
        start: {
          line: 252,
          column: 4
        },
        end: {
          line: 325,
          column: 5
        }
      },
      "82": {
        start: {
          line: 258,
          column: 21
        },
        end: {
          line: 258,
          column: 51
        }
      },
      "83": {
        start: {
          line: 259,
          column: 26
        },
        end: {
          line: 259,
          column: 59
        }
      },
      "84": {
        start: {
          line: 260,
          column: 8
        },
        end: {
          line: 260,
          column: 92
        }
      },
      "85": {
        start: {
          line: 260,
          column: 58
        },
        end: {
          line: 260,
          column: 85
        }
      },
      "86": {
        start: {
          line: 261,
          column: 8
        },
        end: {
          line: 261,
          column: 84
        }
      },
      "87": {
        start: {
          line: 262,
          column: 8
        },
        end: {
          line: 267,
          column: 10
        }
      },
      "88": {
        start: {
          line: 271,
          column: 8
        },
        end: {
          line: 275,
          column: 15
        }
      },
      "89": {
        start: {
          line: 273,
          column: 14
        },
        end: {
          line: 273,
          column: 61
        }
      },
      "90": {
        start: {
          line: 276,
          column: 8
        },
        end: {
          line: 276,
          column: 84
        }
      },
      "91": {
        start: {
          line: 277,
          column: 8
        },
        end: {
          line: 282,
          column: 10
        }
      },
      "92": {
        start: {
          line: 285,
          column: 8
        },
        end: {
          line: 289,
          column: 15
        }
      },
      "93": {
        start: {
          line: 287,
          column: 14
        },
        end: {
          line: 287,
          column: 70
        }
      },
      "94": {
        start: {
          line: 290,
          column: 8
        },
        end: {
          line: 290,
          column: 84
        }
      },
      "95": {
        start: {
          line: 291,
          column: 8
        },
        end: {
          line: 296,
          column: 10
        }
      },
      "96": {
        start: {
          line: 299,
          column: 8
        },
        end: {
          line: 301,
          column: 10
        }
      },
      "97": {
        start: {
          line: 300,
          column: 10
        },
        end: {
          line: 300,
          column: 78
        }
      },
      "98": {
        start: {
          line: 302,
          column: 8
        },
        end: {
          line: 302,
          column: 84
        }
      },
      "99": {
        start: {
          line: 303,
          column: 8
        },
        end: {
          line: 308,
          column: 10
        }
      },
      "100": {
        start: {
          line: 311,
          column: 8
        },
        end: {
          line: 315,
          column: 15
        }
      },
      "101": {
        start: {
          line: 313,
          column: 14
        },
        end: {
          line: 313,
          column: 69
        }
      },
      "102": {
        start: {
          line: 316,
          column: 8
        },
        end: {
          line: 321,
          column: 10
        }
      },
      "103": {
        start: {
          line: 324,
          column: 8
        },
        end: {
          line: 324,
          column: 18
        }
      },
      "104": {
        start: {
          line: 332,
          column: 16
        },
        end: {
          line: 347,
          column: 3
        }
      },
      "105": {
        start: {
          line: 333,
          column: 4
        },
        end: {
          line: 333,
          column: 23
        }
      },
      "106": {
        start: {
          line: 334,
          column: 4
        },
        end: {
          line: 345,
          column: 5
        }
      },
      "107": {
        start: {
          line: 336,
          column: 8
        },
        end: {
          line: 338,
          column: 9
        }
      },
      "108": {
        start: {
          line: 337,
          column: 10
        },
        end: {
          line: 337,
          column: 56
        }
      },
      "109": {
        start: {
          line: 339,
          column: 8
        },
        end: {
          line: 339,
          column: 14
        }
      },
      "110": {
        start: {
          line: 341,
          column: 8
        },
        end: {
          line: 341,
          column: 48
        }
      },
      "111": {
        start: {
          line: 342,
          column: 8
        },
        end: {
          line: 342,
          column: 14
        }
      },
      "112": {
        start: {
          line: 344,
          column: 8
        },
        end: {
          line: 344,
          column: 14
        }
      },
      "113": {
        start: {
          line: 346,
          column: 4
        },
        end: {
          line: 346,
          column: 16
        }
      },
      "114": {
        start: {
          line: 352,
          column: 16
        },
        end: {
          line: 364,
          column: 3
        }
      },
      "115": {
        start: {
          line: 353,
          column: 18
        },
        end: {
          line: 353,
          column: 35
        }
      },
      "116": {
        start: {
          line: 354,
          column: 4
        },
        end: {
          line: 357,
          column: 5
        }
      },
      "117": {
        start: {
          line: 355,
          column: 6
        },
        end: {
          line: 355,
          column: 30
        }
      },
      "118": {
        start: {
          line: 356,
          column: 6
        },
        end: {
          line: 356,
          column: 32
        }
      },
      "119": {
        start: {
          line: 358,
          column: 4
        },
        end: {
          line: 363,
          column: 6
        }
      },
      "120": {
        start: {
          line: 361,
          column: 8
        },
        end: {
          line: 361,
          column: 62
        }
      },
      "121": {
        start: {
          line: 369,
          column: 20
        },
        end: {
          line: 373,
          column: 3
        }
      },
      "122": {
        start: {
          line: 371,
          column: 4
        },
        end: {
          line: 371,
          column: 92
        }
      },
      "123": {
        start: {
          line: 372,
          column: 4
        },
        end: {
          line: 372,
          column: 31
        }
      },
      "124": {
        start: {
          line: 375,
          column: 15
        },
        end: {
          line: 377,
          column: 3
        }
      },
      "125": {
        start: {
          line: 376,
          column: 4
        },
        end: {
          line: 376,
          column: 85
        }
      },
      "126": {
        start: {
          line: 376,
          column: 31
        },
        end: {
          line: 376,
          column: 73
        }
      },
      "127": {
        start: {
          line: 382,
          column: 23
        },
        end: {
          line: 388,
          column: 3
        }
      },
      "128": {
        start: {
          line: 383,
          column: 4
        },
        end: {
          line: 387,
          column: 7
        }
      },
      "129": {
        start: {
          line: 393,
          column: 20
        },
        end: {
          line: 397,
          column: 3
        }
      },
      "130": {
        start: {
          line: 394,
          column: 27
        },
        end: {
          line: 394,
          column: 60
        }
      },
      "131": {
        start: {
          line: 396,
          column: 4
        },
        end: {
          line: 396,
          column: 76
        }
      },
      "132": {
        start: {
          line: 396,
          column: 53
        },
        end: {
          line: 396,
          column: 74
        }
      },
      "133": {
        start: {
          line: 399,
          column: 28
        },
        end: {
          line: 401,
          column: 3
        }
      },
      "134": {
        start: {
          line: 400,
          column: 4
        },
        end: {
          line: 400,
          column: 66
        }
      },
      "135": {
        start: {
          line: 400,
          column: 38
        },
        end: {
          line: 400,
          column: 63
        }
      },
      "136": {
        start: {
          line: 414,
          column: 8
        },
        end: {
          line: 414,
          column: 18
        }
      },
      "137": {
        start: {
          line: 415,
          column: 26
        },
        end: {
          line: 415,
          column: 36
        }
      },
      "138": {
        start: {
          line: 416,
          column: 30
        },
        end: {
          line: 416,
          column: 55
        }
      },
      "139": {
        start: {
          line: 417,
          column: 35
        },
        end: {
          line: 417,
          column: 68
        }
      },
      "140": {
        start: {
          line: 418,
          column: 20
        },
        end: {
          line: 418,
          column: 45
        }
      },
      "141": {
        start: {
          line: 419,
          column: 26
        },
        end: {
          line: 419,
          column: 48
        }
      },
      "142": {
        start: {
          line: 420,
          column: 31
        },
        end: {
          line: 425,
          column: 8
        }
      },
      "143": {
        start: {
          line: 421,
          column: 6
        },
        end: {
          line: 423,
          column: 7
        }
      },
      "144": {
        start: {
          line: 422,
          column: 8
        },
        end: {
          line: 422,
          column: 39
        }
      },
      "145": {
        start: {
          line: 424,
          column: 6
        },
        end: {
          line: 424,
          column: 23
        }
      },
      "146": {
        start: {
          line: 426,
          column: 28
        },
        end: {
          line: 426,
          column: 78
        }
      },
      "147": {
        start: {
          line: 427,
          column: 21
        },
        end: {
          line: 427,
          column: 84
        }
      },
      "148": {
        start: {
          line: 429,
          column: 25
        },
        end: {
          line: 434,
          column: 8
        }
      },
      "149": {
        start: {
          line: 430,
          column: 6
        },
        end: {
          line: 432,
          column: 7
        }
      },
      "150": {
        start: {
          line: 431,
          column: 8
        },
        end: {
          line: 431,
          column: 37
        }
      },
      "151": {
        start: {
          line: 433,
          column: 6
        },
        end: {
          line: 433,
          column: 24
        }
      },
      "152": {
        start: {
          line: 437,
          column: 6
        },
        end: {
          line: 439,
          column: 25
        }
      },
      "153": {
        start: {
          line: 443,
          column: 45
        },
        end: {
          line: 445,
          column: 34
        }
      },
      "154": {
        start: {
          line: 446,
          column: 38
        },
        end: {
          line: 446,
          column: 102
        }
      },
      "155": {
        start: {
          line: 447,
          column: 4
        },
        end: {
          line: 749,
          column: 6
        }
      },
      "156": {
        start: {
          line: 471,
          column: 26
        },
        end: {
          line: 471,
          column: 51
        }
      },
      "157": {
        start: {
          line: 481,
          column: 35
        },
        end: {
          line: 481,
          column: 99
        }
      },
      "158": {
        start: {
          line: 484,
          column: 16
        },
        end: {
          line: 486,
          column: 24
        }
      },
      "159": {
        start: {
          line: 489,
          column: 16
        },
        end: {
          line: 491,
          column: 30
        }
      },
      "160": {
        start: {
          line: 494,
          column: 14
        },
        end: {
          line: 670,
          column: 15
        }
      },
      "161": {
        start: {
          line: 496,
          column: 18
        },
        end: {
          line: 498,
          column: 19
        }
      },
      "162": {
        start: {
          line: 497,
          column: 20
        },
        end: {
          line: 497,
          column: 135
        }
      },
      "163": {
        start: {
          line: 499,
          column: 18
        },
        end: {
          line: 515,
          column: 20
        }
      },
      "164": {
        start: {
          line: 516,
          column: 18
        },
        end: {
          line: 526,
          column: 20
        }
      },
      "165": {
        start: {
          line: 527,
          column: 18
        },
        end: {
          line: 527,
          column: 24
        }
      },
      "166": {
        start: {
          line: 530,
          column: 18
        },
        end: {
          line: 533,
          column: 57
        }
      },
      "167": {
        start: {
          line: 535,
          column: 18
        },
        end: {
          line: 549,
          column: 19
        }
      },
      "168": {
        start: {
          line: 540,
          column: 20
        },
        end: {
          line: 548,
          column: 22
        }
      },
      "169": {
        start: {
          line: 550,
          column: 18
        },
        end: {
          line: 567,
          column: 20
        }
      },
      "170": {
        start: {
          line: 568,
          column: 18
        },
        end: {
          line: 586,
          column: 20
        }
      },
      "171": {
        start: {
          line: 579,
          column: 33
        },
        end: {
          line: 579,
          column: 58
        }
      },
      "172": {
        start: {
          line: 587,
          column: 18
        },
        end: {
          line: 587,
          column: 24
        }
      },
      "173": {
        start: {
          line: 598,
          column: 18
        },
        end: {
          line: 617,
          column: 19
        }
      },
      "174": {
        start: {
          line: 599,
          column: 20
        },
        end: {
          line: 616,
          column: 22
        }
      },
      "175": {
        start: {
          line: 618,
          column: 18
        },
        end: {
          line: 618,
          column: 24
        }
      },
      "176": {
        start: {
          line: 621,
          column: 18
        },
        end: {
          line: 646,
          column: 19
        }
      },
      "177": {
        start: {
          line: 622,
          column: 20
        },
        end: {
          line: 645,
          column: 22
        }
      },
      "178": {
        start: {
          line: 647,
          column: 18
        },
        end: {
          line: 647,
          column: 24
        }
      },
      "179": {
        start: {
          line: 651,
          column: 18
        },
        end: {
          line: 666,
          column: 20
        }
      },
      "180": {
        start: {
          line: 667,
          column: 18
        },
        end: {
          line: 667,
          column: 24
        }
      },
      "181": {
        start: {
          line: 669,
          column: 18
        },
        end: {
          line: 669,
          column: 24
        }
      },
      "182": {
        start: {
          line: 672,
          column: 14
        },
        end: {
          line: 726,
          column: 23
        }
      },
      "183": {
        start: {
          line: 676,
          column: 32
        },
        end: {
          line: 676,
          column: 63
        }
      },
      "184": {
        start: {
          line: 753,
          column: 0
        },
        end: {
          line: 779,
          column: 2
        }
      },
      "185": {
        start: {
          line: 780,
          column: 0
        },
        end: {
          line: 793,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 71,
            column: 36
          },
          end: {
            line: 71,
            column: 37
          }
        },
        loc: {
          start: {
            line: 71,
            column: 54
          },
          end: {
            line: 87,
            column: 3
          }
        },
        line: 71
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 89,
            column: 2
          },
          end: {
            line: 89,
            column: 3
          }
        },
        loc: {
          start: {
            line: 89,
            column: 21
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 89
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 111,
            column: 20
          },
          end: {
            line: 111,
            column: 21
          }
        },
        loc: {
          start: {
            line: 111,
            column: 66
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 111
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 111,
            column: 66
          },
          end: {
            line: 111,
            column: 67
          }
        },
        loc: {
          start: {
            line: 111,
            column: 75
          },
          end: {
            line: 140,
            column: 3
          }
        },
        line: 111
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 142,
            column: 29
          },
          end: {
            line: 142,
            column: 30
          }
        },
        loc: {
          start: {
            line: 142,
            column: 37
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 142
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 142,
            column: 37
          },
          end: {
            line: 142,
            column: 38
          }
        },
        loc: {
          start: {
            line: 142,
            column: 49
          },
          end: {
            line: 160,
            column: 3
          }
        },
        line: 142
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 165,
            column: 33
          },
          end: {
            line: 165,
            column: 34
          }
        },
        loc: {
          start: {
            line: 165,
            column: 41
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 165
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 165,
            column: 41
          },
          end: {
            line: 165,
            column: 42
          }
        },
        loc: {
          start: {
            line: 165,
            column: 53
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 165
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 169,
            column: 60
          },
          end: {
            line: 169,
            column: 61
          }
        },
        loc: {
          start: {
            line: 169,
            column: 67
          },
          end: {
            line: 169,
            column: 76
          }
        },
        line: 169
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 210,
            column: 22
          },
          end: {
            line: 210,
            column: 23
          }
        },
        loc: {
          start: {
            line: 210,
            column: 32
          },
          end: {
            line: 214,
            column: 3
          }
        },
        line: 210
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 210,
            column: 32
          },
          end: {
            line: 210,
            column: 33
          }
        },
        loc: {
          start: {
            line: 210,
            column: 38
          },
          end: {
            line: 214,
            column: 3
          }
        },
        line: 210
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 216,
            column: 28
          },
          end: {
            line: 216,
            column: 29
          }
        },
        loc: {
          start: {
            line: 216,
            column: 55
          },
          end: {
            line: 226,
            column: 3
          }
        },
        line: 216
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 228,
            column: 21
          },
          end: {
            line: 228,
            column: 22
          }
        },
        loc: {
          start: {
            line: 228,
            column: 47
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 228
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 240,
            column: 25
          },
          end: {
            line: 240,
            column: 26
          }
        },
        loc: {
          start: {
            line: 240,
            column: 62
          },
          end: {
            line: 326,
            column: 3
          }
        },
        line: 240
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 260,
            column: 50
          },
          end: {
            line: 260,
            column: 51
          }
        },
        loc: {
          start: {
            line: 260,
            column: 58
          },
          end: {
            line: 260,
            column: 85
          }
        },
        line: 260
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 272,
            column: 49
          },
          end: {
            line: 272,
            column: 50
          }
        },
        loc: {
          start: {
            line: 273,
            column: 14
          },
          end: {
            line: 273,
            column: 61
          }
        },
        line: 273
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 286,
            column: 46
          },
          end: {
            line: 286,
            column: 47
          }
        },
        loc: {
          start: {
            line: 287,
            column: 14
          },
          end: {
            line: 287,
            column: 70
          }
        },
        line: 287
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 299,
            column: 57
          },
          end: {
            line: 299,
            column: 58
          }
        },
        loc: {
          start: {
            line: 300,
            column: 10
          },
          end: {
            line: 300,
            column: 78
          }
        },
        line: 300
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 312,
            column: 47
          },
          end: {
            line: 312,
            column: 48
          }
        },
        loc: {
          start: {
            line: 313,
            column: 14
          },
          end: {
            line: 313,
            column: 69
          }
        },
        line: 313
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 332,
            column: 16
          },
          end: {
            line: 332,
            column: 17
          }
        },
        loc: {
          start: {
            line: 332,
            column: 35
          },
          end: {
            line: 347,
            column: 3
          }
        },
        line: 332
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 352,
            column: 16
          },
          end: {
            line: 352,
            column: 17
          }
        },
        loc: {
          start: {
            line: 352,
            column: 21
          },
          end: {
            line: 364,
            column: 3
          }
        },
        line: 352
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 360,
            column: 6
          },
          end: {
            line: 360,
            column: 7
          }
        },
        loc: {
          start: {
            line: 360,
            column: 12
          },
          end: {
            line: 362,
            column: 7
          }
        },
        line: 360
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 369,
            column: 20
          },
          end: {
            line: 369,
            column: 21
          }
        },
        loc: {
          start: {
            line: 369,
            column: 26
          },
          end: {
            line: 373,
            column: 3
          }
        },
        line: 369
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 375,
            column: 15
          },
          end: {
            line: 375,
            column: 16
          }
        },
        loc: {
          start: {
            line: 375,
            column: 43
          },
          end: {
            line: 377,
            column: 3
          }
        },
        line: 375
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 376,
            column: 18
          },
          end: {
            line: 376,
            column: 19
          }
        },
        loc: {
          start: {
            line: 376,
            column: 31
          },
          end: {
            line: 376,
            column: 73
          }
        },
        line: 376
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 382,
            column: 23
          },
          end: {
            line: 382,
            column: 24
          }
        },
        loc: {
          start: {
            line: 382,
            column: 29
          },
          end: {
            line: 388,
            column: 3
          }
        },
        line: 382
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 393,
            column: 20
          },
          end: {
            line: 393,
            column: 21
          }
        },
        loc: {
          start: {
            line: 393,
            column: 26
          },
          end: {
            line: 397,
            column: 3
          }
        },
        line: 393
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 396,
            column: 44
          },
          end: {
            line: 396,
            column: 45
          }
        },
        loc: {
          start: {
            line: 396,
            column: 53
          },
          end: {
            line: 396,
            column: 74
          }
        },
        line: 396
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 399,
            column: 28
          },
          end: {
            line: 399,
            column: 29
          }
        },
        loc: {
          start: {
            line: 399,
            column: 34
          },
          end: {
            line: 401,
            column: 3
          }
        },
        line: 399
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 400,
            column: 18
          },
          end: {
            line: 400,
            column: 19
          }
        },
        loc: {
          start: {
            line: 400,
            column: 38
          },
          end: {
            line: 400,
            column: 63
          }
        },
        line: 400
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 403,
            column: 2
          },
          end: {
            line: 403,
            column: 3
          }
        },
        loc: {
          start: {
            line: 403,
            column: 11
          },
          end: {
            line: 750,
            column: 3
          }
        },
        line: 403
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 420,
            column: 32
          },
          end: {
            line: 420,
            column: 33
          }
        },
        loc: {
          start: {
            line: 420,
            column: 38
          },
          end: {
            line: 425,
            column: 5
          }
        },
        line: 420
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 429,
            column: 26
          },
          end: {
            line: 429,
            column: 27
          }
        },
        loc: {
          start: {
            line: 429,
            column: 32
          },
          end: {
            line: 434,
            column: 5
          }
        },
        line: 429
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 471,
            column: 21
          },
          end: {
            line: 471,
            column: 22
          }
        },
        loc: {
          start: {
            line: 471,
            column: 26
          },
          end: {
            line: 471,
            column: 51
          }
        },
        line: 471
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 473,
            column: 28
          },
          end: {
            line: 473,
            column: 29
          }
        },
        loc: {
          start: {
            line: 473,
            column: 42
          },
          end: {
            line: 727,
            column: 13
          }
        },
        line: 473
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 579,
            column: 26
          },
          end: {
            line: 579,
            column: 27
          }
        },
        loc: {
          start: {
            line: 579,
            column: 33
          },
          end: {
            line: 579,
            column: 58
          }
        },
        line: 579
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 676,
            column: 27
          },
          end: {
            line: 676,
            column: 28
          }
        },
        loc: {
          start: {
            line: 676,
            column: 32
          },
          end: {
            line: 676,
            column: 63
          }
        },
        line: 676
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 72
      },
      "1": {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 85
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 44
          }
        }, {
          start: {
            line: 72,
            column: 48
          },
          end: {
            line: 72,
            column: 85
          }
        }],
        line: 72
      },
      "2": {
        loc: {
          start: {
            line: 101,
            column: 17
          },
          end: {
            line: 101,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 101,
            column: 17
          },
          end: {
            line: 101,
            column: 45
          }
        }, {
          start: {
            line: 101,
            column: 49
          },
          end: {
            line: 101,
            column: 65
          }
        }],
        line: 101
      },
      "3": {
        loc: {
          start: {
            line: 111,
            column: 34
          },
          end: {
            line: 111,
            column: 61
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 111,
            column: 57
          },
          end: {
            line: 111,
            column: 61
          }
        }],
        line: 111
      },
      "4": {
        loc: {
          start: {
            line: 115,
            column: 21
          },
          end: {
            line: 115,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 115,
            column: 30
          },
          end: {
            line: 115,
            column: 35
          }
        }, {
          start: {
            line: 115,
            column: 38
          },
          end: {
            line: 115,
            column: 42
          }
        }],
        line: 115
      },
      "5": {
        loc: {
          start: {
            line: 116,
            column: 4
          },
          end: {
            line: 132,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 117,
            column: 6
          },
          end: {
            line: 122,
            column: 14
          }
        }, {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 129,
            column: 14
          }
        }, {
          start: {
            line: 130,
            column: 6
          },
          end: {
            line: 131,
            column: 14
          }
        }],
        line: 116
      },
      "6": {
        loc: {
          start: {
            line: 125,
            column: 10
          },
          end: {
            line: 126,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 10
          },
          end: {
            line: 125,
            column: 66
          }
        }, {
          start: {
            line: 126,
            column: 10
          },
          end: {
            line: 126,
            column: 66
          }
        }],
        line: 125
      },
      "7": {
        loc: {
          start: {
            line: 125,
            column: 42
          },
          end: {
            line: 125,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 125,
            column: 42
          },
          end: {
            line: 125,
            column: 50
          }
        }, {
          start: {
            line: 125,
            column: 54
          },
          end: {
            line: 125,
            column: 65
          }
        }],
        line: 125
      },
      "8": {
        loc: {
          start: {
            line: 126,
            column: 42
          },
          end: {
            line: 126,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 126,
            column: 42
          },
          end: {
            line: 126,
            column: 50
          }
        }, {
          start: {
            line: 126,
            column: 54
          },
          end: {
            line: 126,
            column: 65
          }
        }],
        line: 126
      },
      "9": {
        loc: {
          start: {
            line: 127,
            column: 37
          },
          end: {
            line: 127,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 37
          },
          end: {
            line: 127,
            column: 45
          }
        }, {
          start: {
            line: 127,
            column: 49
          },
          end: {
            line: 127,
            column: 60
          }
        }],
        line: 127
      },
      "10": {
        loc: {
          start: {
            line: 128,
            column: 37
          },
          end: {
            line: 128,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 128,
            column: 37
          },
          end: {
            line: 128,
            column: 45
          }
        }, {
          start: {
            line: 128,
            column: 49
          },
          end: {
            line: 128,
            column: 60
          }
        }],
        line: 128
      },
      "11": {
        loc: {
          start: {
            line: 138,
            column: 6
          },
          end: {
            line: 138,
            column: 75
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 138,
            column: 52
          },
          end: {
            line: 138,
            column: 68
          }
        }, {
          start: {
            line: 138,
            column: 71
          },
          end: {
            line: 138,
            column: 75
          }
        }],
        line: 138
      },
      "12": {
        loc: {
          start: {
            line: 138,
            column: 6
          },
          end: {
            line: 138,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 138,
            column: 6
          },
          end: {
            line: 138,
            column: 11
          }
        }, {
          start: {
            line: 138,
            column: 15
          },
          end: {
            line: 138,
            column: 25
          }
        }, {
          start: {
            line: 138,
            column: 29
          },
          end: {
            line: 138,
            column: 49
          }
        }],
        line: 138
      },
      "13": {
        loc: {
          start: {
            line: 145,
            column: 25
          },
          end: {
            line: 145,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 54
          },
          end: {
            line: 145,
            column: 62
          }
        }, {
          start: {
            line: 145,
            column: 65
          },
          end: {
            line: 145,
            column: 69
          }
        }],
        line: 145
      },
      "14": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 155,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 147,
            column: 6
          },
          end: {
            line: 149,
            column: 14
          }
        }, {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 152,
            column: 14
          }
        }, {
          start: {
            line: 153,
            column: 6
          },
          end: {
            line: 154,
            column: 14
          }
        }],
        line: 146
      },
      "15": {
        loc: {
          start: {
            line: 169,
            column: 25
          },
          end: {
            line: 169,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 169,
            column: 47
          },
          end: {
            line: 169,
            column: 77
          }
        }, {
          start: {
            line: 169,
            column: 80
          },
          end: {
            line: 169,
            column: 84
          }
        }],
        line: 169
      },
      "16": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 197,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 171,
            column: 6
          },
          end: {
            line: 171,
            column: 28
          }
        }, {
          start: {
            line: 172,
            column: 6
          },
          end: {
            line: 172,
            column: 28
          }
        }, {
          start: {
            line: 173,
            column: 6
          },
          end: {
            line: 173,
            column: 28
          }
        }, {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 174,
            column: 29
          }
        }, {
          start: {
            line: 175,
            column: 6
          },
          end: {
            line: 178,
            column: 14
          }
        }, {
          start: {
            line: 179,
            column: 6
          },
          end: {
            line: 182,
            column: 14
          }
        }, {
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 186,
            column: 14
          }
        }, {
          start: {
            line: 187,
            column: 6
          },
          end: {
            line: 190,
            column: 14
          }
        }, {
          start: {
            line: 191,
            column: 6
          },
          end: {
            line: 194,
            column: 14
          }
        }, {
          start: {
            line: 195,
            column: 6
          },
          end: {
            line: 196,
            column: 14
          }
        }],
        line: 170
      },
      "17": {
        loc: {
          start: {
            line: 203,
            column: 6
          },
          end: {
            line: 203,
            column: 42
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 203,
            column: 19
          },
          end: {
            line: 203,
            column: 35
          }
        }, {
          start: {
            line: 203,
            column: 38
          },
          end: {
            line: 203,
            column: 42
          }
        }],
        line: 203
      },
      "18": {
        loc: {
          start: {
            line: 212,
            column: 6
          },
          end: {
            line: 212,
            column: 98
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 45
          },
          end: {
            line: 212,
            column: 69
          }
        }, {
          start: {
            line: 212,
            column: 72
          },
          end: {
            line: 212,
            column: 98
          }
        }],
        line: 212
      },
      "19": {
        loc: {
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 217,
            column: 4
          },
          end: {
            line: 224,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 217
      },
      "20": {
        loc: {
          start: {
            line: 225,
            column: 11
          },
          end: {
            line: 225,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 225,
            column: 32
          },
          end: {
            line: 225,
            column: 50
          }
        }, {
          start: {
            line: 225,
            column: 53
          },
          end: {
            line: 225,
            column: 55
          }
        }],
        line: 225
      },
      "21": {
        loc: {
          start: {
            line: 229,
            column: 4
          },
          end: {
            line: 236,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 231,
            column: 85
          }
        }, {
          start: {
            line: 232,
            column: 6
          },
          end: {
            line: 233,
            column: 93
          }
        }, {
          start: {
            line: 234,
            column: 6
          },
          end: {
            line: 235,
            column: 18
          }
        }],
        line: 229
      },
      "22": {
        loc: {
          start: {
            line: 231,
            column: 15
          },
          end: {
            line: 231,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 231,
            column: 53
          },
          end: {
            line: 231,
            column: 79
          }
        }, {
          start: {
            line: 231,
            column: 82
          },
          end: {
            line: 231,
            column: 84
          }
        }],
        line: 231
      },
      "23": {
        loc: {
          start: {
            line: 233,
            column: 15
          },
          end: {
            line: 233,
            column: 92
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 233,
            column: 57
          },
          end: {
            line: 233,
            column: 87
          }
        }, {
          start: {
            line: 233,
            column: 90
          },
          end: {
            line: 233,
            column: 92
          }
        }],
        line: 233
      },
      "24": {
        loc: {
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 241,
            column: 4
          },
          end: {
            line: 243,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 241
      },
      "25": {
        loc: {
          start: {
            line: 252,
            column: 4
          },
          end: {
            line: 325,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 253,
            column: 6
          },
          end: {
            line: 253,
            column: 28
          }
        }, {
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 28
          }
        }, {
          start: {
            line: 255,
            column: 6
          },
          end: {
            line: 255,
            column: 28
          }
        }, {
          start: {
            line: 256,
            column: 6
          },
          end: {
            line: 256,
            column: 29
          }
        }, {
          start: {
            line: 257,
            column: 6
          },
          end: {
            line: 268,
            column: 7
          }
        }, {
          start: {
            line: 270,
            column: 6
          },
          end: {
            line: 282,
            column: 10
          }
        }, {
          start: {
            line: 284,
            column: 6
          },
          end: {
            line: 296,
            column: 10
          }
        }, {
          start: {
            line: 298,
            column: 6
          },
          end: {
            line: 308,
            column: 10
          }
        }, {
          start: {
            line: 310,
            column: 6
          },
          end: {
            line: 321,
            column: 10
          }
        }, {
          start: {
            line: 323,
            column: 6
          },
          end: {
            line: 324,
            column: 18
          }
        }],
        line: 252
      },
      "26": {
        loc: {
          start: {
            line: 260,
            column: 26
          },
          end: {
            line: 260,
            column: 91
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 260,
            column: 38
          },
          end: {
            line: 260,
            column: 86
          }
        }, {
          start: {
            line: 260,
            column: 89
          },
          end: {
            line: 260,
            column: 91
          }
        }],
        line: 260
      },
      "27": {
        loc: {
          start: {
            line: 271,
            column: 26
          },
          end: {
            line: 275,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 272,
            column: 12
          },
          end: {
            line: 274,
            column: 13
          }
        }, {
          start: {
            line: 275,
            column: 12
          },
          end: {
            line: 275,
            column: 14
          }
        }],
        line: 271
      },
      "28": {
        loc: {
          start: {
            line: 285,
            column: 26
          },
          end: {
            line: 289,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 286,
            column: 12
          },
          end: {
            line: 288,
            column: 13
          }
        }, {
          start: {
            line: 289,
            column: 12
          },
          end: {
            line: 289,
            column: 14
          }
        }],
        line: 285
      },
      "29": {
        loc: {
          start: {
            line: 300,
            column: 11
          },
          end: {
            line: 300,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 300,
            column: 11
          },
          end: {
            line: 300,
            column: 46
          }
        }, {
          start: {
            line: 300,
            column: 50
          },
          end: {
            line: 300,
            column: 52
          }
        }],
        line: 300
      },
      "30": {
        loc: {
          start: {
            line: 311,
            column: 26
          },
          end: {
            line: 315,
            column: 14
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 312,
            column: 12
          },
          end: {
            line: 314,
            column: 13
          }
        }, {
          start: {
            line: 315,
            column: 12
          },
          end: {
            line: 315,
            column: 14
          }
        }],
        line: 311
      },
      "31": {
        loc: {
          start: {
            line: 334,
            column: 4
          },
          end: {
            line: 345,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 335,
            column: 6
          },
          end: {
            line: 339,
            column: 14
          }
        }, {
          start: {
            line: 340,
            column: 6
          },
          end: {
            line: 342,
            column: 14
          }
        }, {
          start: {
            line: 343,
            column: 6
          },
          end: {
            line: 344,
            column: 14
          }
        }],
        line: 334
      },
      "32": {
        loc: {
          start: {
            line: 336,
            column: 8
          },
          end: {
            line: 338,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 336,
            column: 8
          },
          end: {
            line: 338,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 336
      },
      "33": {
        loc: {
          start: {
            line: 353,
            column: 18
          },
          end: {
            line: 353,
            column: 35
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 353,
            column: 18
          },
          end: {
            line: 353,
            column: 19
          }
        }, {
          start: {
            line: 353,
            column: 23
          },
          end: {
            line: 353,
            column: 35
          }
        }],
        line: 353
      },
      "34": {
        loc: {
          start: {
            line: 354,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 354,
            column: 4
          },
          end: {
            line: 357,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 354
      },
      "35": {
        loc: {
          start: {
            line: 354,
            column: 8
          },
          end: {
            line: 354,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 354,
            column: 8
          },
          end: {
            line: 354,
            column: 13
          }
        }, {
          start: {
            line: 354,
            column: 17
          },
          end: {
            line: 354,
            column: 29
          }
        }],
        line: 354
      },
      "36": {
        loc: {
          start: {
            line: 421,
            column: 6
          },
          end: {
            line: 423,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 421,
            column: 6
          },
          end: {
            line: 423,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 421
      },
      "37": {
        loc: {
          start: {
            line: 426,
            column: 28
          },
          end: {
            line: 426,
            column: 78
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 426,
            column: 55
          },
          end: {
            line: 426,
            column: 62
          }
        }, {
          start: {
            line: 426,
            column: 65
          },
          end: {
            line: 426,
            column: 78
          }
        }],
        line: 426
      },
      "38": {
        loc: {
          start: {
            line: 427,
            column: 21
          },
          end: {
            line: 427,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 427,
            column: 48
          },
          end: {
            line: 427,
            column: 63
          }
        }, {
          start: {
            line: 427,
            column: 66
          },
          end: {
            line: 427,
            column: 84
          }
        }],
        line: 427
      },
      "39": {
        loc: {
          start: {
            line: 430,
            column: 6
          },
          end: {
            line: 432,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 430,
            column: 6
          },
          end: {
            line: 432,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 430
      },
      "40": {
        loc: {
          start: {
            line: 443,
            column: 45
          },
          end: {
            line: 445,
            column: 34
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 444,
            column: 8
          },
          end: {
            line: 444,
            column: 22
          }
        }, {
          start: {
            line: 445,
            column: 8
          },
          end: {
            line: 445,
            column: 34
          }
        }],
        line: 443
      },
      "41": {
        loc: {
          start: {
            line: 446,
            column: 38
          },
          end: {
            line: 446,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 446,
            column: 38
          },
          end: {
            line: 446,
            column: 60
          }
        }, {
          start: {
            line: 446,
            column: 65
          },
          end: {
            line: 446,
            column: 87
          }
        }, {
          start: {
            line: 446,
            column: 91
          },
          end: {
            line: 446,
            column: 101
          }
        }],
        line: 446
      },
      "42": {
        loc: {
          start: {
            line: 449,
            column: 9
          },
          end: {
            line: 468,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 449,
            column: 9
          },
          end: {
            line: 449,
            column: 34
          }
        }, {
          start: {
            line: 450,
            column: 10
          },
          end: {
            line: 467,
            column: 35
          }
        }],
        line: 449
      },
      "43": {
        loc: {
          start: {
            line: 454,
            column: 46
          },
          end: {
            line: 454,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 454,
            column: 58
          },
          end: {
            line: 454,
            column: 72
          }
        }, {
          start: {
            line: 454,
            column: 75
          },
          end: {
            line: 454,
            column: 88
          }
        }],
        line: 454
      },
      "44": {
        loc: {
          start: {
            line: 457,
            column: 13
          },
          end: {
            line: 466,
            column: 13
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 457,
            column: 13
          },
          end: {
            line: 457,
            column: 26
          }
        }, {
          start: {
            line: 458,
            column: 14
          },
          end: {
            line: 465,
            column: 42
          }
        }],
        line: 457
      },
      "45": {
        loc: {
          start: {
            line: 469,
            column: 9
          },
          end: {
            line: 747,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 469,
            column: 10
          },
          end: {
            line: 469,
            column: 20
          }
        }, {
          start: {
            line: 469,
            column: 24
          },
          end: {
            line: 469,
            column: 50
          }
        }, {
          start: {
            line: 470,
            column: 10
          },
          end: {
            line: 746,
            column: 20
          }
        }],
        line: 469
      },
      "46": {
        loc: {
          start: {
            line: 484,
            column: 16
          },
          end: {
            line: 486,
            column: 24
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 485,
            column: 18
          },
          end: {
            line: 485,
            column: 82
          }
        }, {
          start: {
            line: 486,
            column: 20
          },
          end: {
            line: 486,
            column: 24
          }
        }],
        line: 484
      },
      "47": {
        loc: {
          start: {
            line: 494,
            column: 14
          },
          end: {
            line: 670,
            column: 15
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 495,
            column: 16
          },
          end: {
            line: 527,
            column: 24
          }
        }, {
          start: {
            line: 529,
            column: 16
          },
          end: {
            line: 587,
            column: 24
          }
        }, {
          start: {
            line: 589,
            column: 16
          },
          end: {
            line: 589,
            column: 38
          }
        }, {
          start: {
            line: 590,
            column: 16
          },
          end: {
            line: 590,
            column: 38
          }
        }, {
          start: {
            line: 591,
            column: 16
          },
          end: {
            line: 591,
            column: 38
          }
        }, {
          start: {
            line: 592,
            column: 16
          },
          end: {
            line: 592,
            column: 39
          }
        }, {
          start: {
            line: 593,
            column: 16
          },
          end: {
            line: 593,
            column: 39
          }
        }, {
          start: {
            line: 594,
            column: 16
          },
          end: {
            line: 594,
            column: 44
          }
        }, {
          start: {
            line: 595,
            column: 16
          },
          end: {
            line: 595,
            column: 50
          }
        }, {
          start: {
            line: 596,
            column: 16
          },
          end: {
            line: 618,
            column: 24
          }
        }, {
          start: {
            line: 620,
            column: 16
          },
          end: {
            line: 647,
            column: 24
          }
        }, {
          start: {
            line: 649,
            column: 16
          },
          end: {
            line: 649,
            column: 46
          }
        }, {
          start: {
            line: 650,
            column: 16
          },
          end: {
            line: 667,
            column: 24
          }
        }, {
          start: {
            line: 668,
            column: 16
          },
          end: {
            line: 669,
            column: 24
          }
        }],
        line: 494
      },
      "48": {
        loc: {
          start: {
            line: 496,
            column: 18
          },
          end: {
            line: 498,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 496,
            column: 18
          },
          end: {
            line: 498,
            column: 19
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 496
      },
      "49": {
        loc: {
          start: {
            line: 496,
            column: 22
          },
          end: {
            line: 496,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 496,
            column: 22
          },
          end: {
            line: 496,
            column: 44
          }
        }, {
          start: {
            line: 496,
            column: 48
          },
          end: {
            line: 496,
            column: 75
          }
        }],
        line: 496
      },
      "50": {
        loc: {
          start: {
            line: 501,
            column: 23
          },
          end: {
            line: 505,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 501,
            column: 23
          },
          end: {
            line: 501,
            column: 47
          }
        }, {
          start: {
            line: 502,
            column: 24
          },
          end: {
            line: 504,
            column: 38
          }
        }],
        line: 501
      },
      "51": {
        loc: {
          start: {
            line: 509,
            column: 26
          },
          end: {
            line: 509,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 509,
            column: 72
          },
          end: {
            line: 509,
            column: 94
          }
        }, {
          start: {
            line: 509,
            column: 97
          },
          end: {
            line: 509,
            column: 99
          }
        }],
        line: 509
      },
      "52": {
        loc: {
          start: {
            line: 509,
            column: 26
          },
          end: {
            line: 509,
            column: 69
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 509,
            column: 26
          },
          end: {
            line: 509,
            column: 43
          }
        }, {
          start: {
            line: 509,
            column: 47
          },
          end: {
            line: 509,
            column: 69
          }
        }],
        line: 509
      },
      "53": {
        loc: {
          start: {
            line: 522,
            column: 23
          },
          end: {
            line: 524,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 522,
            column: 23
          },
          end: {
            line: 522,
            column: 39
          }
        }, {
          start: {
            line: 523,
            column: 24
          },
          end: {
            line: 523,
            column: 87
          }
        }],
        line: 522
      },
      "54": {
        loc: {
          start: {
            line: 531,
            column: 20
          },
          end: {
            line: 533,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 531,
            column: 20
          },
          end: {
            line: 531,
            column: 37
          }
        }, {
          start: {
            line: 532,
            column: 20
          },
          end: {
            line: 532,
            column: 56
          }
        }, {
          start: {
            line: 533,
            column: 20
          },
          end: {
            line: 533,
            column: 56
          }
        }],
        line: 531
      },
      "55": {
        loc: {
          start: {
            line: 535,
            column: 18
          },
          end: {
            line: 549,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 535,
            column: 18
          },
          end: {
            line: 549,
            column: 19
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 535
      },
      "56": {
        loc: {
          start: {
            line: 536,
            column: 20
          },
          end: {
            line: 538,
            column: 61
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 536,
            column: 20
          },
          end: {
            line: 536,
            column: 42
          }
        }, {
          start: {
            line: 537,
            column: 20
          },
          end: {
            line: 537,
            column: 61
          }
        }, {
          start: {
            line: 538,
            column: 20
          },
          end: {
            line: 538,
            column: 61
          }
        }],
        line: 536
      },
      "57": {
        loc: {
          start: {
            line: 557,
            column: 26
          },
          end: {
            line: 559,
            column: 80
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 558,
            column: 30
          },
          end: {
            line: 558,
            column: 86
          }
        }, {
          start: {
            line: 559,
            column: 30
          },
          end: {
            line: 559,
            column: 80
          }
        }],
        line: 557
      },
      "58": {
        loc: {
          start: {
            line: 582,
            column: 23
          },
          end: {
            line: 584,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 582,
            column: 23
          },
          end: {
            line: 582,
            column: 39
          }
        }, {
          start: {
            line: 583,
            column: 24
          },
          end: {
            line: 583,
            column: 87
          }
        }],
        line: 582
      },
      "59": {
        loc: {
          start: {
            line: 598,
            column: 18
          },
          end: {
            line: 617,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 598,
            column: 18
          },
          end: {
            line: 617,
            column: 19
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 598
      },
      "60": {
        loc: {
          start: {
            line: 621,
            column: 18
          },
          end: {
            line: 646,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 621,
            column: 18
          },
          end: {
            line: 646,
            column: 19
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 621
      },
      "61": {
        loc: {
          start: {
            line: 672,
            column: 21
          },
          end: {
            line: 726,
            column: 22
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 673,
            column: 16
          },
          end: {
            line: 725,
            column: 38
          }
        }, {
          start: {
            line: 726,
            column: 18
          },
          end: {
            line: 726,
            column: 22
          }
        }],
        line: 672
      },
      "62": {
        loc: {
          start: {
            line: 677,
            column: 19
          },
          end: {
            line: 701,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 677,
            column: 19
          },
          end: {
            line: 677,
            column: 34
          }
        }, {
          start: {
            line: 678,
            column: 20
          },
          end: {
            line: 700,
            column: 34
          }
        }],
        line: 677
      },
      "63": {
        loc: {
          start: {
            line: 690,
            column: 27
          },
          end: {
            line: 696,
            column: 27
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 690,
            column: 27
          },
          end: {
            line: 690,
            column: 43
          }
        }, {
          start: {
            line: 691,
            column: 28
          },
          end: {
            line: 695,
            column: 47
          }
        }],
        line: 690
      },
      "64": {
        loc: {
          start: {
            line: 703,
            column: 19
          },
          end: {
            line: 712,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 703,
            column: 19
          },
          end: {
            line: 703,
            column: 42
          }
        }, {
          start: {
            line: 704,
            column: 20
          },
          end: {
            line: 711,
            column: 34
          }
        }],
        line: 703
      },
      "65": {
        loc: {
          start: {
            line: 713,
            column: 19
          },
          end: {
            line: 724,
            column: 19
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 713,
            column: 19
          },
          end: {
            line: 713,
            column: 43
          }
        }, {
          start: {
            line: 714,
            column: 20
          },
          end: {
            line: 723,
            column: 45
          }
        }],
        line: 713
      },
      "66": {
        loc: {
          start: {
            line: 720,
            column: 23
          },
          end: {
            line: 722,
            column: 23
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 720,
            column: 23
          },
          end: {
            line: 720,
            column: 45
          }
        }, {
          start: {
            line: 721,
            column: 24
          },
          end: {
            line: 721,
            column: 62
          }
        }],
        line: 720
      },
      "67": {
        loc: {
          start: {
            line: 729,
            column: 15
          },
          end: {
            line: 739,
            column: 17
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 729,
            column: 15
          },
          end: {
            line: 729,
            column: 28
          }
        }, {
          start: {
            line: 730,
            column: 16
          },
          end: {
            line: 730,
            column: 42
          }
        }, {
          start: {
            line: 731,
            column: 18
          },
          end: {
            line: 738,
            column: 46
          }
        }],
        line: 729
      },
      "68": {
        loc: {
          start: {
            line: 740,
            column: 15
          },
          end: {
            line: 744,
            column: 15
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 740,
            column: 16
          },
          end: {
            line: 740,
            column: 29
          }
        }, {
          start: {
            line: 740,
            column: 33
          },
          end: {
            line: 740,
            column: 57
          }
        }, {
          start: {
            line: 741,
            column: 16
          },
          end: {
            line: 743,
            column: 38
          }
        }],
        line: 740
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0, 0],
      "13": [0, 0],
      "14": [0, 0, 0],
      "15": [0, 0],
      "16": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0, 0],
      "46": [0, 0],
      "47": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0, 0],
      "55": [0, 0],
      "56": [0, 0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0, 0],
      "68": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "97edfe9addefd6e5382ae00f67590dd479cbc739"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_21uayl3lxb = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_21uayl3lxb();
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? _Reflect$construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CLOSE_ICON_SIZE = (cov_21uayl3lxb().s[0]++, 24);
var RESET_ICON_SIZE = (cov_21uayl3lxb().s[1]++, 22);
var ICON_SIZE = (cov_21uayl3lxb().s[2]++, 16);
var DEFAULT_RANGE_PRICE = (cov_21uayl3lxb().s[3]++, {
  min: 0,
  max: 1000000
});
var KEY_CODE = (cov_21uayl3lxb().s[4]++, {
  ENTER: 13,
  ESCAPE: 27
});

/**
 * Component that displays a set of buttons (filters), so when clicking one of them a popup will show the filter content.
 * Once a filter is updated, this return the filter modified and new value to the parent component.
 */
var FilterBar = /*#__PURE__*/function (_PureComponent) {
  function FilterBar(props) {
    var _this;
    (0, _classCallCheck2.default)(this, FilterBar);
    cov_21uayl3lxb().f[1]++;
    cov_21uayl3lxb().s[9]++;
    _this = _callSuper(this, FilterBar, [props]);
    /**
     * Method to handle when a filter has been changed, in the parent component will be executed the action to filter the list of results or call the API endpoint
     * @param {object} elem, Object with information sent from the filter component when this has been changed.
     * @param {boolean} reset, true if we are resetting one specific filter
     * @param immediateApplyFilter automatically apply filter when the filter criteria was changed.
     */
    (0, _defineProperty2.default)(_this, "onFilterChanged", (cov_21uayl3lxb().s[11]++, function (elem, reset) {
      var immediateApplyFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_21uayl3lxb().b[3][0]++, true);
      cov_21uayl3lxb().f[2]++;
      cov_21uayl3lxb().s[12]++;
      return function (value) {
        cov_21uayl3lxb().f[3]++;
        // Update the state
        var sameValue = (cov_21uayl3lxb().s[13]++, false);
        var auxFilterCriteria = (cov_21uayl3lxb().s[14]++, (0, _assign.default)({}, _this.state.filterCriteria));
        var auxValue = (cov_21uayl3lxb().s[15]++, !reset ? (cov_21uayl3lxb().b[4][0]++, value) : (cov_21uayl3lxb().b[4][1]++, null));
        cov_21uayl3lxb().s[16]++;
        switch (elem) {
          case 'date':
            cov_21uayl3lxb().b[5][0]++;
            cov_21uayl3lxb().s[17]++;
            sameValue = auxFilterCriteria.date === auxValue;
            cov_21uayl3lxb().s[18]++;
            auxFilterCriteria.date = auxValue;
            cov_21uayl3lxb().s[19]++;
            auxFilterCriteria.fromDate = auxValue;
            cov_21uayl3lxb().s[20]++;
            auxFilterCriteria.toDate = auxValue;
            cov_21uayl3lxb().s[21]++;
            break;
          case 'price':
            cov_21uayl3lxb().b[5][1]++;
            cov_21uayl3lxb().s[22]++;
            sameValue = (cov_21uayl3lxb().b[6][0]++, auxFilterCriteria.minPrice === ((cov_21uayl3lxb().b[7][0]++, auxValue) && (cov_21uayl3lxb().b[7][1]++, auxValue[0]))) && (cov_21uayl3lxb().b[6][1]++, auxFilterCriteria.maxPrice === ((cov_21uayl3lxb().b[8][0]++, auxValue) && (cov_21uayl3lxb().b[8][1]++, auxValue[0])));
            cov_21uayl3lxb().s[23]++;
            auxFilterCriteria.minPrice = (cov_21uayl3lxb().b[9][0]++, auxValue) && (cov_21uayl3lxb().b[9][1]++, auxValue[0]);
            cov_21uayl3lxb().s[24]++;
            auxFilterCriteria.maxPrice = (cov_21uayl3lxb().b[10][0]++, auxValue) && (cov_21uayl3lxb().b[10][1]++, auxValue[1]);
            cov_21uayl3lxb().s[25]++;
            break;
          default:
            cov_21uayl3lxb().b[5][2]++;
            cov_21uayl3lxb().s[26]++;
            break;
        }
        cov_21uayl3lxb().s[27]++;
        _this.setState({
          filterCriteria: auxFilterCriteria
        }, (cov_21uayl3lxb().b[12][0]++, reset) && (cov_21uayl3lxb().b[12][1]++, !sameValue) && (cov_21uayl3lxb().b[12][2]++, immediateApplyFilter) ? (cov_21uayl3lxb().b[11][0]++, _this.applyFilter) : (cov_21uayl3lxb().b[11][1]++, null));
      };
    }));
    (0, _defineProperty2.default)(_this, "onInputTextFilterChanged", (cov_21uayl3lxb().s[28]++, function (elem) {
      cov_21uayl3lxb().f[4]++;
      cov_21uayl3lxb().s[29]++;
      return function (auxValue) {
        cov_21uayl3lxb().f[5]++;
        var auxFilterCriteria = (cov_21uayl3lxb().s[30]++, (0, _assign.default)({}, _this.state.filterCriteria));
        var auxValueData = (cov_21uayl3lxb().s[31]++, auxValue.trim().length > 0 ? (cov_21uayl3lxb().b[13][0]++, auxValue) : (cov_21uayl3lxb().b[13][1]++, null));
        cov_21uayl3lxb().s[32]++;
        switch (elem) {
          case _filter.FilterField.PRODUCT_NAME:
            cov_21uayl3lxb().b[14][0]++;
            cov_21uayl3lxb().s[33]++;
            auxFilterCriteria.productName = auxValueData;
            cov_21uayl3lxb().s[34]++;
            break;
          case _filter.FilterField.PRODUCT_LINE_NAME:
            cov_21uayl3lxb().b[14][1]++;
            cov_21uayl3lxb().s[35]++;
            auxFilterCriteria.productLineName = auxValueData;
            cov_21uayl3lxb().s[36]++;
            break;
          default:
            cov_21uayl3lxb().b[14][2]++;
            cov_21uayl3lxb().s[37]++;
            break;
        }
        cov_21uayl3lxb().s[38]++;
        _this.setState({
          filterCriteria: auxFilterCriteria
        });
      };
    }));
    /*
    *  Hanlde MultiDropdown filter - On selected event
    * */
    (0, _defineProperty2.default)(_this, "onMultiDropDownFilterChanged", (cov_21uayl3lxb().s[39]++, function (elem) {
      cov_21uayl3lxb().f[6]++;
      cov_21uayl3lxb().s[40]++;
      return function (auxValue) {
        cov_21uayl3lxb().f[7]++;
        // Update the state
        var sameValue = (cov_21uayl3lxb().s[41]++, false);
        var auxFilterCriteria = (cov_21uayl3lxb().s[42]++, (0, _assign.default)({}, _this.state.filterCriteria));
        var auxValueData = (cov_21uayl3lxb().s[43]++, auxValue.length > 0 ? (cov_21uayl3lxb().b[15][0]++, auxValue.map(function (obj) {
          cov_21uayl3lxb().f[8]++;
          cov_21uayl3lxb().s[44]++;
          return obj.value;
        })) : (cov_21uayl3lxb().b[15][1]++, null));
        cov_21uayl3lxb().s[45]++;
        switch (elem) {
          case _filter.FilterField.CITY:
            cov_21uayl3lxb().b[16][0]++;
          case _filter.FilterField.SITE:
            cov_21uayl3lxb().b[16][1]++;
          case _filter.FilterField.TEAM:
            cov_21uayl3lxb().b[16][2]++;
          case _filter.FilterField.SPACE:
            cov_21uayl3lxb().b[16][3]++;
          case _filter.FilterField.TOPIC:
            cov_21uayl3lxb().b[16][4]++;
            cov_21uayl3lxb().s[46]++;
            // siteIds, teamIds, spaceIds or topicIds
            sameValue = (0, _get.default)(auxFilterCriteria, "".concat(elem, "Ids"), []) === auxValueData;
            cov_21uayl3lxb().s[47]++;
            auxFilterCriteria["".concat(elem, "Ids")] = auxValueData;
            cov_21uayl3lxb().s[48]++;
            break;
          case _filter.FilterField.MATCH_NAME:
            cov_21uayl3lxb().b[16][5]++;
            cov_21uayl3lxb().s[49]++;
            sameValue = auxFilterCriteria.matchNames === auxValueData;
            cov_21uayl3lxb().s[50]++;
            auxFilterCriteria.matchNames = auxValueData;
            cov_21uayl3lxb().s[51]++;
            break;
          case _filter.FilterField.HOSPITALITY_TYPE:
            cov_21uayl3lxb().b[16][6]++;
            cov_21uayl3lxb().s[52]++;
            sameValue = auxFilterCriteria.hospProductTypes === auxValueData;
            cov_21uayl3lxb().s[53]++;
            auxFilterCriteria.hospProductTypes = auxValueData;
            cov_21uayl3lxb().s[54]++;
            break;
          case _filter.FilterField.PRODUCT_TYPES:
            cov_21uayl3lxb().b[16][7]++;
            cov_21uayl3lxb().s[55]++;
            sameValue = auxFilterCriteria.customProductTypeIds === auxValueData;
            cov_21uayl3lxb().s[56]++;
            auxFilterCriteria.customProductTypeIds = auxValueData;
            cov_21uayl3lxb().s[57]++;
            break;
          case _filter.FilterField.ORDER_PRODUCT_BY:
            cov_21uayl3lxb().b[16][8]++;
            cov_21uayl3lxb().s[58]++;
            sameValue = auxFilterCriteria.productOrderBy === auxValueData;
            cov_21uayl3lxb().s[59]++;
            auxFilterCriteria.productOrderBy = auxValueData;
            cov_21uayl3lxb().s[60]++;
            break;
          default:
            cov_21uayl3lxb().b[16][9]++;
            cov_21uayl3lxb().s[61]++;
            break;
        }
        cov_21uayl3lxb().s[62]++;
        _this.setState({
          filterCriteria: auxFilterCriteria
        }, !sameValue ? (cov_21uayl3lxb().b[17][0]++, _this.applyFilter) : (cov_21uayl3lxb().b[17][1]++, null));
      };
    }));
    /**
     * Method to display/hide the filters as we can only display open one of them.
     */
    (0, _defineProperty2.default)(_this, "onCollapseChanged", (cov_21uayl3lxb().s[63]++, function (filter) {
      cov_21uayl3lxb().f[9]++;
      cov_21uayl3lxb().s[64]++;
      return function () {
        cov_21uayl3lxb().f[10]++;
        cov_21uayl3lxb().s[65]++;
        _this.setState(_this.state.currentVisible === filter ? (cov_21uayl3lxb().b[18][0]++, {
          currentVisible: null
        }) : (cov_21uayl3lxb().b[18][1]++, {
          currentVisible: filter
        }));
      };
    }));
    (0, _defineProperty2.default)(_this, "getCustomSelectedOption", (cov_21uayl3lxb().s[66]++, function (selectedOptions, elem) {
      cov_21uayl3lxb().f[11]++;
      cov_21uayl3lxb().s[67]++;
      if (selectedOptions.length > 1) {
        cov_21uayl3lxb().b[19][0]++;
        cov_21uayl3lxb().s[68]++;
        return /*#__PURE__*/_react.default.createElement("span", {
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 219,
            columnNumber: 9
          }
        }, selectedOptions.length, ' ', /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: "gravity.FilterBar.multiDropdown.".concat(elem, ".pluralText"),
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 221,
            columnNumber: 11
          }
        }));
      } else {
        cov_21uayl3lxb().b[19][1]++;
      }
      cov_21uayl3lxb().s[69]++;
      return selectedOptions[0] ? (cov_21uayl3lxb().b[20][0]++, selectedOptions[0]) : (cov_21uayl3lxb().b[20][1]++, '');
    }));
    (0, _defineProperty2.default)(_this, "getInputTextData", (cov_21uayl3lxb().s[70]++, function (elem, filterCriteria) {
      cov_21uayl3lxb().f[12]++;
      cov_21uayl3lxb().s[71]++;
      switch (elem) {
        case _filter.FilterField.PRODUCT_NAME:
          cov_21uayl3lxb().b[21][0]++;
          cov_21uayl3lxb().s[72]++;
          return filterCriteria.productName !== null ? (cov_21uayl3lxb().b[22][0]++, filterCriteria.productName) : (cov_21uayl3lxb().b[22][1]++, '');
        case _filter.FilterField.PRODUCT_LINE_NAME:
          cov_21uayl3lxb().b[21][1]++;
          cov_21uayl3lxb().s[73]++;
          return filterCriteria.productLineName !== null ? (cov_21uayl3lxb().b[23][0]++, filterCriteria.productLineName) : (cov_21uayl3lxb().b[23][1]++, '');
        default:
          cov_21uayl3lxb().b[21][2]++;
          cov_21uayl3lxb().s[74]++;
          return '';
      }
    }));
    /* Methode to prepare data for multiDropdown */
    (0, _defineProperty2.default)(_this, "getMultiDropDownData", (cov_21uayl3lxb().s[75]++, function (elem, filter, newFilterCriteria) {
      cov_21uayl3lxb().f[13]++;
      cov_21uayl3lxb().s[76]++;
      if (!filter) {
        cov_21uayl3lxb().b[24][0]++;
        cov_21uayl3lxb().s[77]++;
        return {};
      } else {
        cov_21uayl3lxb().b[24][1]++;
      }
      var availableFilterOptions = (cov_21uayl3lxb().s[78]++, _this.state.availableFilterOptions);
      var filterCriteria = (cov_21uayl3lxb().s[79]++, (0, _assign.default)({}, newFilterCriteria));
      var selectedOptions;
      var customSelectedOptions;
      var placeholderText = (cov_21uayl3lxb().s[80]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.FilterBar.multiDropdown.".concat(elem, ".placeholder"),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 249,
          columnNumber: 7
        }
      }));
      cov_21uayl3lxb().s[81]++;
      switch (elem) {
        case _filter.FilterField.CITY:
          cov_21uayl3lxb().b[25][0]++;
        case _filter.FilterField.SITE:
          cov_21uayl3lxb().b[25][1]++;
        case _filter.FilterField.TEAM:
          cov_21uayl3lxb().b[25][2]++;
        case _filter.FilterField.SPACE:
          cov_21uayl3lxb().b[25][3]++;
        case _filter.FilterField.TOPIC:
          cov_21uayl3lxb().b[25][4]++;
          {
            var data = (cov_21uayl3lxb().s[82]++, (0, _get.default)(filter, "".concat(elem, "Data"), [])); // teamData, spaceData, topicData or siteData
            var filterIds = (cov_21uayl3lxb().s[83]++, (0, _get.default)(filterCriteria, "".concat(elem, "Ids"))); // teamIds, spaceIds, topicIds or siteIds
            cov_21uayl3lxb().s[84]++;
            selectedOptions = filterIds ? (cov_21uayl3lxb().b[26][0]++, data.filter(function (item) {
              cov_21uayl3lxb().f[14]++;
              cov_21uayl3lxb().s[85]++;
              return filterIds.includes(item.id);
            })) : (cov_21uayl3lxb().b[26][1]++, []);
            cov_21uayl3lxb().s[86]++;
            customSelectedOptions = _this.getCustomSelectedOption(selectedOptions, elem);
            cov_21uayl3lxb().s[87]++;
            return {
              listOptions: (0, _get.default)(availableFilterOptions, "".concat(elem, "Data"), []),
              selectedValues: selectedOptions,
              placeholder: placeholderText,
              customSelectedValues: customSelectedOptions
            };
          }
        case _filter.FilterField.MATCH_NAME:
          cov_21uayl3lxb().b[25][5]++;
          cov_21uayl3lxb().s[88]++;
          selectedOptions = filterCriteria.matchNames ? (cov_21uayl3lxb().b[27][0]++, filter.hospitalitySessionData.filter(function (match) {
            cov_21uayl3lxb().f[15]++;
            cov_21uayl3lxb().s[89]++;
            return filterCriteria.matchNames.includes(match.value);
          })) : (cov_21uayl3lxb().b[27][1]++, []);
          cov_21uayl3lxb().s[90]++;
          customSelectedOptions = _this.getCustomSelectedOption(selectedOptions, elem);
          cov_21uayl3lxb().s[91]++;
          return {
            listOptions: availableFilterOptions.hospitalitySessionData,
            selectedValues: selectedOptions,
            placeholder: placeholderText,
            customSelectedValues: customSelectedOptions
          };
        case _filter.FilterField.HOSPITALITY_TYPE:
          cov_21uayl3lxb().b[25][6]++;
          cov_21uayl3lxb().s[92]++;
          selectedOptions = filterCriteria.hospProductTypes ? (cov_21uayl3lxb().b[28][0]++, filter.hospitalityTypeData.filter(function (hospType) {
            cov_21uayl3lxb().f[16]++;
            cov_21uayl3lxb().s[93]++;
            return filterCriteria.hospProductTypes.includes(hospType.value);
          })) : (cov_21uayl3lxb().b[28][1]++, []);
          cov_21uayl3lxb().s[94]++;
          customSelectedOptions = _this.getCustomSelectedOption(selectedOptions, elem);
          cov_21uayl3lxb().s[95]++;
          return {
            listOptions: filter.hospitalityTypeData,
            selectedValues: selectedOptions,
            placeholder: placeholderText,
            customSelectedValues: customSelectedOptions
          };
        case _filter.FilterField.PRODUCT_TYPES:
          cov_21uayl3lxb().b[25][7]++;
          cov_21uayl3lxb().s[96]++;
          selectedOptions = filter.productTypesData.filter(function (prodType) {
            cov_21uayl3lxb().f[17]++;
            cov_21uayl3lxb().s[97]++;
            return ((cov_21uayl3lxb().b[29][0]++, filterCriteria.customProductTypeIds) || (cov_21uayl3lxb().b[29][1]++, [])).includes(prodType.value);
          });
          cov_21uayl3lxb().s[98]++;
          customSelectedOptions = _this.getCustomSelectedOption(selectedOptions, elem);
          cov_21uayl3lxb().s[99]++;
          return {
            listOptions: filter.productTypesData,
            placeholder: placeholderText,
            selectedValues: selectedOptions,
            customSelectedValues: customSelectedOptions
          };
        case _filter.FilterField.ORDER_PRODUCT_BY:
          cov_21uayl3lxb().b[25][8]++;
          cov_21uayl3lxb().s[100]++;
          selectedOptions = filterCriteria.productOrderBy ? (cov_21uayl3lxb().b[30][0]++, filter.orderProductTypeData.filter(function (orderType) {
            cov_21uayl3lxb().f[18]++;
            cov_21uayl3lxb().s[101]++;
            return filterCriteria.productOrderBy.includes(orderType.value);
          })) : (cov_21uayl3lxb().b[30][1]++, []);
          cov_21uayl3lxb().s[102]++;
          return {
            listOptions: filter.orderProductTypeData,
            selectedValues: selectedOptions,
            placeholder: placeholderText,
            single: true
          };
        default:
          cov_21uayl3lxb().b[25][9]++;
          cov_21uayl3lxb().s[103]++;
          return {};
      }
    }));
    /*
    * Method to increase UX by support keyboard navigation (open, close, move between filter, etc)
    * Currently support: Enter, escape.
    */
    (0, _defineProperty2.default)(_this, "handleKeyUp", (cov_21uayl3lxb().s[104]++, function (e, filterElem) {
      cov_21uayl3lxb().f[19]++;
      cov_21uayl3lxb().s[105]++;
      e.preventDefault();
      cov_21uayl3lxb().s[106]++;
      switch (e.keyCode) {
        case KEY_CODE.ENTER:
          cov_21uayl3lxb().b[31][0]++;
          cov_21uayl3lxb().s[107]++;
          if (filterElem) {
            cov_21uayl3lxb().b[32][0]++;
            cov_21uayl3lxb().s[108]++;
            _this.setState({
              currentVisible: filterElem
            });
          } else {
            cov_21uayl3lxb().b[32][1]++;
          }
          cov_21uayl3lxb().s[109]++;
          break;
        case KEY_CODE.ESCAPE:
          cov_21uayl3lxb().b[31][1]++;
          cov_21uayl3lxb().s[110]++;
          _this.setState({
            currentVisible: null
          });
          cov_21uayl3lxb().s[111]++;
          break;
        default:
          cov_21uayl3lxb().b[31][2]++;
          cov_21uayl3lxb().s[112]++;
          break;
      }
      cov_21uayl3lxb().s[113]++;
      return null;
    }));
    /**
     * Method to apply the filter changed previously.
     */
    (0, _defineProperty2.default)(_this, "applyFilter", (cov_21uayl3lxb().s[114]++, function (e) {
      cov_21uayl3lxb().f[20]++;
      var event = (cov_21uayl3lxb().s[115]++, (cov_21uayl3lxb().b[33][0]++, e) || (cov_21uayl3lxb().b[33][1]++, window.event));
      cov_21uayl3lxb().s[116]++;
      if ((cov_21uayl3lxb().b[35][0]++, event) && (cov_21uayl3lxb().b[35][1]++, event.target)) {
        cov_21uayl3lxb().b[34][0]++;
        cov_21uayl3lxb().s[117]++;
        event.stopPropagation();
        cov_21uayl3lxb().s[118]++;
        event.cancelBubble = true;
      } else {
        cov_21uayl3lxb().b[34][1]++;
      }
      cov_21uayl3lxb().s[119]++;
      _this.setState({
        previousFilterCriteria: _this.state.filterCriteria,
        currentVisible: null
      }, function () {
        cov_21uayl3lxb().f[21]++;
        cov_21uayl3lxb().s[120]++;
        _this.props.onFilterChanged(_this.state.filterCriteria);
      });
    }));
    /**
     * Method to reset all the filters applied
     */
    (0, _defineProperty2.default)(_this, "resetAllFilters", (cov_21uayl3lxb().s[121]++, function () {
      cov_21uayl3lxb().f[22]++;
      cov_21uayl3lxb().s[122]++;
      // Close current visible popup
      _this.setState({
        currentVisible: null,
        filterCriteria: {},
        previousFilterCriteria: {}
      });
      cov_21uayl3lxb().s[123]++;
      _this.props.onFilterReset();
    }));
    (0, _defineProperty2.default)(_this, "mergeState", (cov_21uayl3lxb().s[124]++, function (partialState, callBack) {
      cov_21uayl3lxb().f[23]++;
      cov_21uayl3lxb().s[125]++;
      _this.setState(function (prevState) {
        cov_21uayl3lxb().f[24]++;
        cov_21uayl3lxb().s[126]++;
        return (0, _assign.default)({}, prevState, partialState);
      }, callBack);
    }));
    /**
     * When the user click out of the popup, this is closed
     */
    (0, _defineProperty2.default)(_this, "handlePopUpOnClose", (cov_21uayl3lxb().s[127]++, function () {
      cov_21uayl3lxb().f[25]++;
      cov_21uayl3lxb().s[128]++;
      _this.setState({
        filter: _this.state.initialFilter,
        currentVisible: null,
        filterCriteria: _this.state.previousFilterCriteria
      });
    }));
    /**
     * Method that returns a boolean indicating if there are some filter options applied
     */
    (0, _defineProperty2.default)(_this, "isFilterApplied", (cov_21uayl3lxb().s[129]++, function () {
      cov_21uayl3lxb().f[26]++;
      var filterCriteria = (cov_21uayl3lxb().s[130]++, _this.state.previousFilterCriteria);
      cov_21uayl3lxb().s[131]++;
      return (0, _keys.default)(filterCriteria).some(function (value) {
        cov_21uayl3lxb().f[27]++;
        cov_21uayl3lxb().s[132]++;
        return filterCriteria[value];
      });
    }));
    (0, _defineProperty2.default)(_this, "toggleFilterBarCollapse", (cov_21uayl3lxb().s[133]++, function () {
      cov_21uayl3lxb().f[28]++;
      cov_21uayl3lxb().s[134]++;
      _this.setState(function (_ref) {
        var collapsed = _ref.collapsed;
        cov_21uayl3lxb().f[29]++;
        cov_21uayl3lxb().s[135]++;
        return {
          collapsed: !collapsed
        };
      });
    }));
    cov_21uayl3lxb().s[10]++;
    _this.state = {
      currentVisible: null,
      // Nucleo Filter
      initialFilter: props.filter,
      // Filter without applying action
      filterCriteria: props.filterCriteria,
      previousFilterCriteria: props.filterCriteria,
      arrFilters: props.arrFilters,
      // attempt to fix the broken page. TODO-FJL: please fix double check the correctness
      availableFilterOptions: props.filter,
      collapsed: (cov_21uayl3lxb().b[2][0]++, props.activeScreenQueries.xs) || (cov_21uayl3lxb().b[2][1]++, props.showToggle)
    };
    return _this;
  }
  (0, _inherits2.default)(FilterBar, _PureComponent);
  return (0, _createClass2.default)(FilterBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      cov_21uayl3lxb().f[30]++;
      var _ref2 = (cov_21uayl3lxb().s[136]++, this.props),
        currencyCode = _ref2.currencyCode,
        arrFilters = _ref2.arrFilters,
        filter = _ref2.filter,
        showPastDates = _ref2.showPastDates,
        currentTheme = _ref2.currentTheme,
        themeQueries = _ref2.themeQueries,
        activeScreenQueries = _ref2.activeScreenQueries,
        showToggle = _ref2.showToggle,
        theme = _ref2.theme;
      var _ref3 = (cov_21uayl3lxb().s[137]++, this.state),
        collapsed = _ref3.collapsed;
      var newFilterCriteria = (cov_21uayl3lxb().s[138]++, this.state.filterCriteria);
      var previousFilterCriteria = (cov_21uayl3lxb().s[139]++, this.state.previousFilterCriteria);
      var visible = (cov_21uayl3lxb().s[140]++, this.state.currentVisible);
      var filterApplied = (cov_21uayl3lxb().s[141]++, this.isFilterApplied());
      var resetButtonVariant = (cov_21uayl3lxb().s[142]++, function () {
        cov_21uayl3lxb().f[31]++;
        cov_21uayl3lxb().s[143]++;
        if (themeQueries.EVOLUTION) {
          cov_21uayl3lxb().b[36][0]++;
          cov_21uayl3lxb().s[144]++;
          return _button.ButtonVariant.secondary;
        } else {
          cov_21uayl3lxb().b[36][1]++;
        }
        cov_21uayl3lxb().s[145]++;
        return undefined;
      }());
      var resetButtonIcon = (cov_21uayl3lxb().s[146]++, themeQueries.EQUILIBRIUM ? (cov_21uayl3lxb().b[37][0]++, 'close') : (cov_21uayl3lxb().b[37][1]++, 'riCloseLine'));
      var iconSize = (cov_21uayl3lxb().s[147]++, themeQueries.EQUILIBRIUM ? (cov_21uayl3lxb().b[38][0]++, RESET_ICON_SIZE) : (cov_21uayl3lxb().b[38][1]++, theme.iconFontSize));
      var calendarIcon = (cov_21uayl3lxb().s[148]++, function () {
        cov_21uayl3lxb().f[32]++;
        cov_21uayl3lxb().s[149]++;
        if (themeQueries.EVOLUTION) {
          cov_21uayl3lxb().b[39][0]++;
          cov_21uayl3lxb().s[150]++;
          return 'riCalendarEventLine';
        } else {
          cov_21uayl3lxb().b[39][1]++;
        }
        cov_21uayl3lxb().s[151]++;
        return 'calendar';
      }());
      var closeIcon = (cov_21uayl3lxb().s[152]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.CloseIconWrapper, {
        onClick: this.handlePopUpOnClose,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 437,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: CLOSE_ICON_SIZE,
        iconName: 'close',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 438,
          columnNumber: 9
        }
      })));
      var sortingFilter;
      var ThemedResetAndOrderFilterWrapper = (cov_21uayl3lxb().s[153]++, themeQueries.EQUILIBRIUM ? (cov_21uayl3lxb().b[40][0]++, _react.default.Fragment) : (cov_21uayl3lxb().b[40][1]++, _FilterStyling.ResetAndOrderFilterWrapper));
      var shouldShowCollapsedButton = (cov_21uayl3lxb().s[154]++, (cov_21uayl3lxb().b[41][0]++, themeQueries.EVOLUTION) && ((cov_21uayl3lxb().b[41][1]++, activeScreenQueries.sm) || (cov_21uayl3lxb().b[41][2]++, showToggle)));
      cov_21uayl3lxb().s[155]++;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (cov_21uayl3lxb().b[42][0]++, shouldShowCollapsedButton) && (cov_21uayl3lxb().b[42][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterBarToggleWrapper, {
        filterApplied: filterApplied,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 450,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterBarToggleCollapseButton, {
        variant: _button.ButtonVariant.secondary,
        onClick: this.toggleFilterBarCollapse,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 451,
          columnNumber: 13
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: iconSize,
        iconName: collapsed ? (cov_21uayl3lxb().b[43][0]++, 'riFilterLine') : (cov_21uayl3lxb().b[43][1]++, 'riCloseLine'),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 454,
          columnNumber: 15
        }
      })), (cov_21uayl3lxb().b[44][0]++, filterApplied) && (cov_21uayl3lxb().b[44][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.ButtonResetFiltersWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 458,
          columnNumber: 15
        }
      }, /*#__PURE__*/_react.default.createElement(_FilterStyling.ResetButton, {
        onClick: this.resetAllFilters,
        variant: resetButtonVariant,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 459,
          columnNumber: 17
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: iconSize,
        iconName: resetButtonIcon,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 460,
          columnNumber: 19
        }
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 461,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.FilterBar.button.reset',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 462,
          columnNumber: 21
        }
      }))))))), ((cov_21uayl3lxb().b[45][0]++, !collapsed) || (cov_21uayl3lxb().b[45][1]++, !shouldShowCollapsedButton)) && (cov_21uayl3lxb().b[45][2]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.Wrapper, {
        onKeyUp: function onKeyUp(e) {
          cov_21uayl3lxb().f[33]++;
          cov_21uayl3lxb().s[156]++;
          return _this2.handleKeyUp(e, null);
        },
        showResetButton: !shouldShowCollapsedButton,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 470,
          columnNumber: 11
        }
      }, arrFilters.map(function (filterElem) {
        cov_21uayl3lxb().f[34]++;
        var textComponentBtn;
        var filterComponent;
        var filterComponentBtn;
        var dropDownFilterComponent;
        var inputTextFilterComponent;
        var priceFilterChanged;
        var dropDownData = (cov_21uayl3lxb().s[157]++, _this2.getMultiDropDownData(filterElem, filter, newFilterCriteria));
        // Icon for PRODUCT TYPES
        var productTypeDropdownIcon = (cov_21uayl3lxb().s[158]++, filterElem === _filter.FilterField.PRODUCT_TYPES ? (cov_21uayl3lxb().b[46][0]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.CollapsiblePanelIconWrapper, {
          size: ICON_SIZE,
          iconName: "list",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 485,
            columnNumber: 19
          }
        })) : (cov_21uayl3lxb().b[46][1]++, null));
        var applyBtn = (cov_21uayl3lxb().s[159]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.ApplyButton, {
          onClick: _this2.applyFilter,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 489,
            columnNumber: 17
          }
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.FilterBar.button.apply',
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 490,
            columnNumber: 19
          }
        })));
        cov_21uayl3lxb().s[160]++;
        switch (filterElem) {
          case _filter.FilterField.DATE:
            cov_21uayl3lxb().b[47][0]++;
            cov_21uayl3lxb().s[161]++;
            if ((cov_21uayl3lxb().b[49][0]++, previousFilterCriteria) && (cov_21uayl3lxb().b[49][1]++, previousFilterCriteria.date)) {
              cov_21uayl3lxb().b[48][0]++;
              cov_21uayl3lxb().s[162]++;
              textComponentBtn = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
                value: previousFilterCriteria.date,
                year: "numeric",
                month: "long",
                day: "2-digit",
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 497,
                  columnNumber: 40
                }
              });
            } else {
              cov_21uayl3lxb().b[48][1]++;
            }
            cov_21uayl3lxb().s[163]++;
            filterComponent = /*#__PURE__*/_react.default.createElement("div", {
              className: "g-FilterBar-filterComponent",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 500,
                columnNumber: 21
              }
            }, (cov_21uayl3lxb().b[50][0]++, themeQueries.EQUILIBRIUM) && (cov_21uayl3lxb().b[50][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.HelperTitle, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 502,
                columnNumber: 25
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.date.title",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 503,
                columnNumber: 27
              }
            }))), /*#__PURE__*/_react.default.createElement(_FilterStyling.DatePickerWrapper, {
              embedded: true,
              date: (cov_21uayl3lxb().b[52][0]++, newFilterCriteria) && (cov_21uayl3lxb().b[52][1]++, newFilterCriteria.date) ? (cov_21uayl3lxb().b[51][0]++, newFilterCriteria.date) : (cov_21uayl3lxb().b[51][1]++, ''),
              showPastDates: showPastDates,
              onChange: _this2.onFilterChanged(filterElem, false, false),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 506,
                columnNumber: 23
              }
            }));
            cov_21uayl3lxb().s[164]++;
            filterComponentBtn = /*#__PURE__*/_react.default.createElement("div", {
              className: "g-FilterBar-filterComponentButton",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 517,
                columnNumber: 21
              }
            }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonLabel, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 518,
                columnNumber: 23
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.".concat(filterElem),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 519,
                columnNumber: 25
              }
            })), /*#__PURE__*/_react.default.createElement(_FilterStyling.CollapsiblePanelIconWrapper, {
              size: ICON_SIZE,
              iconName: calendarIcon,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 521,
                columnNumber: 23
              }
            }), (cov_21uayl3lxb().b[53][0]++, textComponentBtn) || (cov_21uayl3lxb().b[53][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.".concat(filterElem),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 523,
                columnNumber: 25
              }
            })));
            cov_21uayl3lxb().s[165]++;
            break;
          case _filter.FilterField.PRICE:
            cov_21uayl3lxb().b[47][1]++;
            cov_21uayl3lxb().s[166]++;
            priceFilterChanged = (cov_21uayl3lxb().b[54][0]++, newFilterCriteria) && (cov_21uayl3lxb().b[54][1]++, (0, _isNumber.default)(newFilterCriteria.minPrice)) && (cov_21uayl3lxb().b[54][2]++, (0, _isNumber.default)(newFilterCriteria.maxPrice));
            cov_21uayl3lxb().s[167]++;
            if ((cov_21uayl3lxb().b[56][0]++, previousFilterCriteria) && (cov_21uayl3lxb().b[56][1]++, (0, _isNumber.default)(previousFilterCriteria.minPrice)) && (cov_21uayl3lxb().b[56][2]++, (0, _isNumber.default)(previousFilterCriteria.maxPrice))) {
              cov_21uayl3lxb().b[55][0]++;
              cov_21uayl3lxb().s[168]++;
              textComponentBtn = /*#__PURE__*/_react.default.createElement(_price.default, {
                labelFrom: '',
                labelTo: ' - ',
                currencyCode: currencyCode,
                minAmount: previousFilterCriteria.minPrice,
                maxAmount: previousFilterCriteria.maxPrice,
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 541,
                  columnNumber: 23
                }
              });
            } else {
              cov_21uayl3lxb().b[55][1]++;
            }
            cov_21uayl3lxb().s[169]++;
            filterComponent = /*#__PURE__*/_react.default.createElement("div", {
              className: "g-FilterBar-filterComponent",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 551,
                columnNumber: 21
              }
            }, /*#__PURE__*/_react.default.createElement(_FilterStyling.HelperTitle, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 552,
                columnNumber: 23
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.price.title",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 553,
                columnNumber: 25
              }
            })), /*#__PURE__*/_react.default.createElement(_priceRangeFilter.default, {
              values: priceFilterChanged ? (cov_21uayl3lxb().b[57][0]++, [newFilterCriteria.minPrice, newFilterCriteria.maxPrice]) : (cov_21uayl3lxb().b[57][1]++, [DEFAULT_RANGE_PRICE.min, DEFAULT_RANGE_PRICE.max]),
              minPrice: DEFAULT_RANGE_PRICE.min,
              maxPrice: DEFAULT_RANGE_PRICE.max,
              currencyCode: currencyCode,
              onApplyFilter: _this2.onFilterChanged(filterElem, false, false),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 555,
                columnNumber: 23
              }
            }));
            cov_21uayl3lxb().s[170]++;
            filterComponentBtn = /*#__PURE__*/_react.default.createElement("div", {
              className: "g-FilterBar-filterComponentButton",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 569,
                columnNumber: 21
              }
            }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonLabel, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 570,
                columnNumber: 23
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.".concat(filterElem),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 571,
                columnNumber: 25
              }
            })), /*#__PURE__*/_react.default.createElement(_FilterStyling.CollapsiblePanelTextWrapper, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 573,
                columnNumber: 23
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedNumber, {
              value: 0,
              style: "currency",
              currency: currencyCode,
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 574,
                columnNumber: 25
              }
            },
            /*
            * It is not possible to get currency code without a value, to ensure that the currency
            * is correctly displayed display value 0 and remove 0,. from the string
            */
            function (num) {
              cov_21uayl3lxb().f[35]++;
              cov_21uayl3lxb().s[171]++;
              return num.replace(/[.,0]/g, '');
            })), (cov_21uayl3lxb().b[58][0]++, textComponentBtn) || (cov_21uayl3lxb().b[58][1]++, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.".concat(filterElem),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 583,
                columnNumber: 25
              }
            })));
            cov_21uayl3lxb().s[172]++;
            break;
          case _filter.FilterField.CITY:
            cov_21uayl3lxb().b[47][2]++;
          case _filter.FilterField.SITE:
            cov_21uayl3lxb().b[47][3]++;
          case _filter.FilterField.TEAM:
            cov_21uayl3lxb().b[47][4]++;
          case _filter.FilterField.SPACE:
            cov_21uayl3lxb().b[47][5]++;
          case _filter.FilterField.TOPIC:
            cov_21uayl3lxb().b[47][6]++;
          case _filter.FilterField.MATCH_NAME:
            cov_21uayl3lxb().b[47][7]++;
          case _filter.FilterField.HOSPITALITY_TYPE:
            cov_21uayl3lxb().b[47][8]++;
          case _filter.FilterField.PRODUCT_TYPES:
            cov_21uayl3lxb().b[47][9]++;
            cov_21uayl3lxb().s[173]++;
            // Not display dropdown that don't have any options
            if ((0, _size.default)(dropDownData.listOptions) > 0) {
              cov_21uayl3lxb().b[59][0]++;
              cov_21uayl3lxb().s[174]++;
              dropDownFilterComponent = /*#__PURE__*/_react.default.createElement(_FilterStyling.MultiDropDownWrapper, {
                key: filterElem,
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 600,
                  columnNumber: 23
                }
              }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonLabel, {
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 601,
                  columnNumber: 25
                }
              }, dropDownData.placeholder), /*#__PURE__*/_react.default.createElement(_multidropdown.default, {
                key: filterElem,
                options: dropDownData.listOptions,
                selectedValues: dropDownData.selectedValues,
                placeholder: dropDownData.placeholder,
                onSelectedValue: _this2.onMultiDropDownFilterChanged(filterElem),
                isOpen: _this2.state.currentVisible === filterElem,
                onClose: _this2.handlePopUpOnClose,
                single: dropDownData.single,
                customSelectedValues: dropDownData.customSelectedValues,
                leftIcon: productTypeDropdownIcon,
                keepPlaceholder: false,
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 602,
                  columnNumber: 25
                }
              }));
            } else {
              cov_21uayl3lxb().b[59][1]++;
            }
            cov_21uayl3lxb().s[175]++;
            break;
          case _filter.FilterField.ORDER_PRODUCT_BY:
            cov_21uayl3lxb().b[47][10]++;
            cov_21uayl3lxb().s[176]++;
            if (dropDownData.listOptions) {
              cov_21uayl3lxb().b[60][0]++;
              cov_21uayl3lxb().s[177]++;
              sortingFilter = /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterPanel, {
                currentTheme: currentTheme,
                key: filterElem,
                className: "g-FilterBar-MultiDropDown",
                collapsed: _this2.state.currentVisible !== filterElem,
                onCollapseChange: _this2.onCollapseChanged(filterElem),
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 623,
                  columnNumber: 23
                }
              }, /*#__PURE__*/_react.default.createElement(_FilterStyling.MultiDropDownWrapper, {
                key: filterElem,
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 629,
                  columnNumber: 25
                }
              }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonLabel, {
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 630,
                  columnNumber: 27
                }
              }, dropDownData.placeholder), /*#__PURE__*/_react.default.createElement(_multidropdown.default, {
                key: filterElem,
                options: dropDownData.listOptions,
                selectedValues: dropDownData.selectedValues,
                placeholder: dropDownData.placeholder,
                onSelectedValue: _this2.onMultiDropDownFilterChanged(filterElem),
                isOpen: _this2.state.currentVisible === filterElem,
                onClose: _this2.handlePopUpOnClose,
                single: dropDownData.single,
                customSelectedValues: dropDownData.customSelectedValues,
                keepPlaceholder: false,
                __self: _this2,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 631,
                  columnNumber: 27
                }
              })));
            } else {
              cov_21uayl3lxb().b[60][1]++;
            }
            cov_21uayl3lxb().s[178]++;
            break;
          case _filter.FilterField.PRODUCT_NAME:
            cov_21uayl3lxb().b[47][11]++;
          case _filter.FilterField.PRODUCT_LINE_NAME:
            cov_21uayl3lxb().b[47][12]++;
            cov_21uayl3lxb().s[179]++;
            inputTextFilterComponent = /*#__PURE__*/_react.default.createElement("div", {
              className: "g-FilterBar-InputTextFilter-Wrapper",
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 652,
                columnNumber: 21
              }
            }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonLabel, {
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 653,
                columnNumber: 23
              }
            }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
              id: "gravity.FilterBar.intputTextFilter.".concat(filterElem, ".placeholder"),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 654,
                columnNumber: 25
              }
            })), /*#__PURE__*/_react.default.createElement(_inputTextFilter.default, {
              key: filterElem,
              value: _this2.getInputTextData(filterElem, newFilterCriteria),
              onChange: _this2.onInputTextFilterChanged(filterElem),
              onSearch: _this2.applyFilter,
              placeholder: "gravity.FilterBar.intputTextFilter.".concat(filterElem, ".placeholder"),
              __self: _this2,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 658,
                columnNumber: 23
              }
            }));
            cov_21uayl3lxb().s[180]++;
            break;
          default:
            cov_21uayl3lxb().b[47][13]++;
            cov_21uayl3lxb().s[181]++;
            break;
        }
        cov_21uayl3lxb().s[182]++;
        return !sortingFilter ? (cov_21uayl3lxb().b[61][0]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonWrapper, {
          key: filterElem,
          id: filterElem,
          onKeyUp: function onKeyUp(e) {
            cov_21uayl3lxb().f[36]++;
            cov_21uayl3lxb().s[183]++;
            return _this2.handleKeyUp(e, filterElem);
          },
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 673,
            columnNumber: 17
          }
        }, (cov_21uayl3lxb().b[62][0]++, filterComponent) && (cov_21uayl3lxb().b[62][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterPanel, {
          currentTheme: currentTheme,
          key: filterElem,
          collapsed: _this2.state.currentVisible !== filterElem,
          onCollapseChange: _this2.onCollapseChanged(filterElem),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 678,
            columnNumber: 21
          }
        }, filterComponentBtn, /*#__PURE__*/_react.default.createElement(_FilterStyling.PopUpWrapper, {
          onClose: _this2.handlePopUpOnClose,
          visible: visible === filterElem,
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 684,
            columnNumber: 23
          }
        }, closeIcon, filterComponent, /*#__PURE__*/_react.default.createElement(_FilterStyling.ActionsWrapper, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 689,
            columnNumber: 25
          }
        }, (cov_21uayl3lxb().b[63][0]++, textComponentBtn) && (cov_21uayl3lxb().b[63][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.ClearPriceButton, {
          variant: resetButtonVariant,
          onClick: _this2.onFilterChanged(filterElem, true),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 691,
            columnNumber: 29
          }
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.FilterBar.button.clear',
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 694,
            columnNumber: 31
          }
        }))), applyBtn)))), (cov_21uayl3lxb().b[64][0]++, dropDownFilterComponent) && (cov_21uayl3lxb().b[64][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterPanel, {
          currentTheme: currentTheme,
          key: filterElem,
          className: "g-FilterBar-MultiDropDown",
          collapsed: _this2.state.currentVisible !== filterElem,
          onCollapseChange: _this2.onCollapseChanged(filterElem),
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 704,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement("span", {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 710,
            columnNumber: 23
          }
        }, dropDownFilterComponent))), (cov_21uayl3lxb().b[65][0]++, inputTextFilterComponent) && (cov_21uayl3lxb().b[65][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.InputTextFilterWrapper, {
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 714,
            columnNumber: 21
          }
        }, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterPanel, {
          key: filterElem,
          className: "g-FilterBar-InputTextFilter",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 715,
            columnNumber: 23
          }
        }, inputTextFilterComponent), (cov_21uayl3lxb().b[66][0]++, themeQueries.EVOLUTION) && (cov_21uayl3lxb().b[66][1]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.SearchIcon, {
          iconName: "riSearchLine",
          __self: _this2,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 721,
            columnNumber: 25
          }
        })))))) : (cov_21uayl3lxb().b[61][1]++, null);
      }), /*#__PURE__*/_react.default.createElement(ThemedResetAndOrderFilterWrapper, {
        showResetButton: !shouldShowCollapsedButton,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 728,
          columnNumber: 13
        }
      }, (cov_21uayl3lxb().b[67][0]++, filterApplied) && (cov_21uayl3lxb().b[67][1]++, !shouldShowCollapsedButton) && (cov_21uayl3lxb().b[67][2]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.ButtonResetFiltersWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 731,
          columnNumber: 19
        }
      }, /*#__PURE__*/_react.default.createElement(_FilterStyling.ResetButton, {
        onClick: this.resetAllFilters,
        variant: resetButtonVariant,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 732,
          columnNumber: 21
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: RESET_ICON_SIZE,
        iconName: 'close',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 733,
          columnNumber: 23
        }
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 734,
          columnNumber: 23
        }
      }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: 'gravity.FilterBar.button.reset',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 735,
          columnNumber: 25
        }
      }))))), ((cov_21uayl3lxb().b[68][0]++, sortingFilter) || (cov_21uayl3lxb().b[68][1]++, themeQueries.EQUILIBRIUM)) && (cov_21uayl3lxb().b[68][2]++, /*#__PURE__*/_react.default.createElement(_FilterStyling.FilterButtonWrapper, {
        sorting: 'true',
        tabIndex: -1,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 741,
          columnNumber: 17
        }
      }, sortingFilter))))));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(FilterBar, "getDerivedStateFromProps", (cov_21uayl3lxb().s[5]++, function (props, state) {
  cov_21uayl3lxb().f[0]++;
  cov_21uayl3lxb().s[6]++;
  if ((cov_21uayl3lxb().b[1][0]++, state.initialFilter !== props.filter) || (cov_21uayl3lxb().b[1][1]++, state.arrFilters !== props.arrFilters)) {
    cov_21uayl3lxb().b[0][0]++;
    cov_21uayl3lxb().s[7]++;
    return {
      initialFilter: props.filter,
      filterCriteria: props.filterCriteria,
      previousFilterCriteria: props.filterCriteria,
      arrFilters: props.arrFilters,
      availableFilterOptions: (0, _helper.buildAvailableOptions)(props.filter, state.availableFilterOptions, props.filterCriteria, (0, _helper.findFieldUpdate)(state.filterCriteria, props.filterCriteria))
    };
  } else {
    cov_21uayl3lxb().b[0][1]++;
  }
  cov_21uayl3lxb().s[8]++;
  return null;
}));
cov_21uayl3lxb().s[184]++;
FilterBar.propTypes = {
  /** Method to handler when the filter has been changed. It returns an object with the filter id and the new value */
  onFilterChanged: _propTypes.default.func.isRequired,
  /** Method to handler when the filter has been reset. */
  onFilterReset: _propTypes.default.func.isRequired,
  /** Filter already applied */
  filter: _propTypes.default.shape(_filter.FilterType),
  /** The needed currency to display prices */
  currencyCode: _propTypes.default.string.isRequired,
  /** True if we want to display past dates in the date filter  */
  showPastDates: _propTypes.default.bool,
  /** The list of supported filters must be displayed */
  arrFilters: _propTypes.default.arrayOf(_propTypes.default.string),
  /** The list of filter criterias */
  filterCriteria: _filter.FilterType,
  /** theme context */
  themeQueries: _utils.WithThemeQueriesType,
  currentTheme: _propTypes.default.string,
  /** screen */
  activeScreenQueries: _utils.WithScreenQueriesType,
  /** Should show toggle */
  showToggle: _propTypes.default.bool,
  /** Styled */
  theme: _propTypes.default.shape({
    iconFontSize: _propTypes.default.number
  })
};
cov_21uayl3lxb().s[185]++;
FilterBar.defaultProps = {
  arrFilters: [_filter.FilterField.DATE, _filter.FilterField.PRICE],
  filterCriteria: {},
  previousFilterCriteria: {},
  filter: {},
  showPastDates: false,
  themeContext: _themeProvider.DEFAULT_THEME_CONTEXT,
  currentTheme: _themeProvider.DEFAULT_THEME_CONTEXT.theme,
  themeQueries: {},
  activeScreenQueries: {},
  activeScreen: 'xs',
  showToggle: false,
  theme: {
    iconFontSize: _themeMapper.evolutionTheme.icon.size
  }
};
var _default = exports.default = (0, _utils.withScreenQueries)((0, _themeProvider.withThemeConsumer)((0, _utils.withThemeQueries)((0, _styledComponents.withTheme)(FilterBar))));